import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Popover,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
    BottomNavigation,
    BottomNavigationAction
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import AndroidIcon from '@material-ui/icons/Android';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import LanguageIcon from '@material-ui/icons/Language';
import SettingsIcon from '@material-ui/icons/Settings';
import CloudIcon from '@material-ui/icons/Cloud';
import StorageIcon from '@material-ui/icons/Storage';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import TuneIcon from '@material-ui/icons/Tune';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import React, { useEffect, useRef, useState } from 'react';
import storage from 'utils/storage'
import SecureLS from 'secure-ls';
import QrReader from 'react-qr-reader';
import user_api from 'utils/api/users'
import {useSnackbar} from 'notistack5'
const moment = require('moment-timezone')
const ls = new SecureLS({encodingType: 'aes'})

// Styled components with mobile responsiveness
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[3],
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[1],
  }
}));

const StyledCard2 = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[3],
  height: '100%',
  border: '4px solid #0B99FF',
  [theme.breakpoints.down('sm')]: {
    borderRadius: theme.spacing(1),
    border: '2px solid #0B99FF',
  }
}));

const TimeButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(3),
  padding: theme.spacing(1.5, 3),
  fontWeight: 'bold',
  textTransform: 'none',
  minHeight: 48,
  fontSize: '0.9rem',
  [theme.breakpoints.down('sm')]: {
    minHeight: 56, // Larger touch target on mobile
    fontSize: '0.8rem',
    padding: theme.spacing(2, 2),
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('xs')]: {
    minHeight: 60,
    fontSize: '0.75rem',
    padding: theme.spacing(2.5, 1),
  },
  '&.time-in': {
    backgroundColor: '#677683',
    color: 'white',
    '&:hover': { backgroundColor: '#2094F3' }
  },
  '&.break-in': {
    backgroundColor: '#677683',
    color: 'white',
    '&:hover': { backgroundColor: '#2094F3' }
  },
  '&.break-out': {
    backgroundColor: '#677683',
    color: 'white',
    '&:hover': { backgroundColor: '#2094F3' }
  },
  '&.time-out': {
    backgroundColor: '#677683',
    color: 'white',
    '&:hover': { backgroundColor: '#2094F3' }
  }
}));

const LogCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  minHeight: 200,
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
    padding: theme.spacing(1.5),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  '&:hover': {
    boxShadow: theme.shadows[4]
  }
}));

const CameraPlaceholder = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '550px',
  backgroundColor: '#000',
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.3s',
  [theme.breakpoints.down('md')]: {
    height: '400px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '220px',
  },
  [theme.breakpoints.down('xs')]: {
    height: '160px',
  },
  '&:hover': {
    backgroundColor: '#333'
  }
}));

const ResponsiveTypography = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.75rem',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.5rem',
  }
}));

const LoadingContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '550px',
  backgroundColor: '#000',
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    height: '400px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '300px',
  },
  [theme.breakpoints.down('xs')]: {
    height: '250px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(45deg, rgba(33, 150, 243, 0.1) 0%, rgba(33, 150, 243, 0.3) 50%, rgba(33, 150, 243, 0.1) 100%)',
    animation: 'shimmer 2s infinite linear',
  },
  '@keyframes shimmer': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '100%': {
      transform: 'translateX(100%)',
    },
  },
}));

const LoadingSpinner = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  border: '4px solid rgba(255, 255, 255, 0.3)',
  borderTop: '4px solid #ffffff',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: 16,
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  [theme.breakpoints.down('sm')]: {
    width: 50,
    height: 50,
    marginBottom: 12,
  },
}));

const PulsingDots = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  marginTop: 12,
  '& .dot': {
    width: 8,
    height: 8,
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    animation: 'pulse 1.4s infinite ease-in-out both',
    '&:nth-child(1)': { animationDelay: '-0.32s' },
    '&:nth-child(2)': { animationDelay: '-0.16s' },
    '&:nth-child(3)': { animationDelay: '0s' },
  },
  '@keyframes pulse': {
    '0%, 80%, 100%': {
      transform: 'scale(0.6)',
      opacity: 0.5,
    },
    '40%': {
      transform: 'scale(1)',
      opacity: 1,
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& .dot': {
      width: 6,
      height: 6,
    },
  },
}));

const QrScanTimeKeep = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [selectedMode, setSelectedMode] = useState('time-in');
  const [scanResult, setScanResult] = useState();
  const [timeLogs, setTimeLogs] = useState([]);
  const [storeName, setStoreName] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [scanMessage, setScanMessage] = useState('Click camera to start scanning');
  const [cameraActive, setCameraActive] = useState(false);
  const [isCameraLoading, setIsCameraLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [facingMode, setFacingMode] = useState('user'); // 'environment' = back, 'user' = front
  const [deviceInfo, setDeviceInfo] = useState({ type: 'unknown', isPWA: false });
  const [isMirrored, setIsMirrored] = useState(true); // Default to mirrored view
  // Current mobile view tab – 'scan' or 'logs'. Desktop always shows both.
  const [mobileTab, setMobileTab] = useState('scan');

  const {enqueueSnackbar} = useSnackbar()
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  })
  const [alwaysOnMode, setAlwaysOnMode] = useState(true); // New state for always-on camera mode
  
  // New states for backend integration
  const [realTimeRecords, setRealTimeRecords] = useState([]);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0);
  const [isLoadingRecords, setIsLoadingRecords] = useState(false);
  const [recordsPage, setRecordsPage] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [user, setUser] = useState(null);
  
  // New states for group store selection
  const [groupStores, setGroupStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState('');

  // New states for storage management
  // Image storage method: default to deviceStorage so users are prompted to pick a folder on first visit
  const [storageMethod, setStorageMethod] = useState('deviceStorage'); // 'localStorage' or 'deviceStorage'
  const [deviceStorageHandle, setDeviceStorageHandle] = useState(null);
  const [storageAuthorized, setStorageAuthorized] = useState(false);
  const [isStorageSettingsOpen, setIsStorageSettingsOpen] = useState(false);
  const [isAuthorizingStorage, setIsAuthorizingStorage] = useState(false);
  const [isReauthDialogOpen, setIsReauthDialogOpen] = useState(false);
  const [hasShownReauthPrompt, setHasShownReauthPrompt] = useState(false);
  const [controlsAnchorEl, setControlsAnchorEl] = useState(null);
  const [isInitialStorageChoiceOpen, setIsInitialStorageChoiceOpen] = useState(false);
  
  // Refs for video capture
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // localStorage management for images
  const IMAGE_STORAGE_PREFIX = 'qr_scan_images_';
  const IMAGE_INDEX_KEY = 'qr_scan_image_index';
  const MIRROR_PREFERENCE_KEY = 'qr_camera_mirror_preference';
  const ALWAYS_ON_PREFERENCE_KEY = 'qr_camera_always_on_preference';
  const STORAGE_METHOD_KEY = 'qr_image_storage_method';
  const DEVICE_STORAGE_HANDLE_KEY = 'qr_device_storage_handle';
  const DEVICE_STORAGE_AUTHORIZED_KEY = 'qr_device_storage_authorized';
  const DEVICE_STORAGE_FOLDER_NAME_KEY = 'qr_device_storage_folder_name';

  // Generate storage key for images
  const generateImageKey = (employeeId, unixTime, status) => {
    // Ensure we do **not** persist the `EMP_` prefix so look-ups that use pure backend IDs work for both
    const cleanEmployeeId = (employeeId || '').replace('EMP_', '');
    return `${IMAGE_STORAGE_PREFIX}${cleanEmployeeId}_${status}_${unixTime}`;
  };

  // Store image in localStorage
  const storeImageLocally = (employeeId, unixTime, status, imageData) => {
    try {
      // Strip EMP_ prefix (if any) so the key matches backend employeeId used during fetch
      const cleanEmployeeId = (employeeId || '').replace('EMP_', '');
      const key = generateImageKey(cleanEmployeeId, unixTime, status);

      // Persist the actual image data
      localStorage.setItem(key, imageData);

      // Maintain a lightweight index for faster look-ups & eventual cleanup
      const indexKey = IMAGE_INDEX_KEY;
      const existingIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
      const newIndex = [...existingIndex, { key, employeeId: cleanEmployeeId, unixTime, status }];
      localStorage.setItem(indexKey, JSON.stringify(newIndex));

      return key;
    } catch (error) {
      console.error('Failed to store image locally:', error);
      return null;
    }
  };

  // Store image in device storage
  const storeImageOnDevice = async (employeeId, unixTime, status, imageData) => {
    try {
      // Clean up employeeId by removing 'EMP_' prefix if present
      const cleanEmployeeId = employeeId.replace('EMP_', '');
      const filename = `${IMAGE_STORAGE_PREFIX}${cleanEmployeeId}_${status}_${unixTime}.jpg`;
      
      
      if ('showDirectoryPicker' in window && deviceStorageHandle) {
        // Use File System Access API for supported browsers
        try {
          const fileHandle = await deviceStorageHandle.getFileHandle(filename, { create: true });
          const writable = await fileHandle.createWritable();
          
          // Convert base64 to blob
          const response = await fetch(imageData);
          const blob = await response.blob();
          
          await writable.write(blob);
          await writable.close();
          return filename;
        } catch (error) {
          console.error('Failed to save to device storage:', error);
          // Fallback to download
          return downloadImage(filename, imageData);
        }
      } else {
        // Fallback to download for unsupported browsers
        return downloadImage(filename, imageData);
      }
    } catch (error) {
      console.error('Failed to store image on device:', error);
      return null;
    }
  };

  // Download image as fallback
  const downloadImage = (filename, imageData) => {
    try {
      const link = document.createElement('a');
      link.href = imageData;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return filename;
    } catch (error) {
      console.error('Failed to download image:', error);
      return null;
    }
  };

  // Check if storage is ready for saving images
  const isStorageReady = () => {
    if (storageMethod === 'localStorage') {
      return true; // localStorage is always available
    } else if (storageMethod === 'deviceStorage') {
      return storageAuthorized; // Device storage needs authorization
    }
    return false;
  };

  // Universal store image function
  const storeImage = async (employeeId, unixTime, status, imageData) => {
    if (!isStorageReady()) {
      console.warn('Storage not ready, falling back to localStorage');
      return storeImageLocally(employeeId, unixTime, status, imageData);
    }
    
    if (storageMethod === 'deviceStorage' && storageAuthorized) {
      return await storeImageOnDevice(employeeId, unixTime, status, imageData);
    } else {
      return storeImageLocally(employeeId, unixTime, status, imageData);
    }
  };

  // Find image by employee ID and Unix timestamp
  const findImageByEmployeeAndTime = async (employeeId, unixTimestamp, status) => {

    if (storageMethod === 'deviceStorage') {
      return await findImageFromDeviceStorage(employeeId, unixTimestamp, status);
    } else {
      return findImageFromLocalStorage(employeeId, unixTimestamp, status);
    }
  };

  // Find image from localStorage (original function)
  const findImageFromLocalStorage = (employeeId, targetUnixTime, status) => {
    try {
      // ---------------------------------------------------------
      // 1. Fast path: attempt **direct key lookup** for exact match
      // ---------------------------------------------------------
      const cleanEmployeeId = (employeeId || '').replace('EMP_', '');
      // Normalize target time to milliseconds
      let targetMs = Number(targetUnixTime);
      if (Number.isNaN(targetMs)) {
        // Attempt ISO parse
        const parsed = Date.parse(targetUnixTime);
        targetMs = Number.isNaN(parsed) ? null : parsed;
      }
      if (targetMs !== null && targetMs < 1e12) {
        // Looks like seconds – convert to ms
        targetMs *= 1000;
      }

      if (targetMs !== null) {
        const directKey = generateImageKey(cleanEmployeeId, targetMs, status);
        const directHit = localStorage.getItem(directKey);
        if (directHit) return directHit;
      }

      // ---------------------------------------------------------
      const indexKey = IMAGE_INDEX_KEY;
      const imageIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
      const candidateImages = imageIndex.filter(
        (item) => item.employeeId === cleanEmployeeId && item.status === status
      );
      if (candidateImages.length === 0 || targetMs === null) return null;

      let bestMatch = null;
      let smallestTimeDiff = Infinity;
      candidateImages.forEach((item) => {
        let itemMs = Number(item.unixTime);
        if (Number.isNaN(itemMs)) {
          const parsed = Date.parse(item.unixTime);
          itemMs = Number.isNaN(parsed) ? null : parsed;
        }
        if (itemMs === null) return;
        if (itemMs < 1e12) itemMs *= 1000; // seconds → ms

        const diff = Math.abs(targetMs - itemMs);
        if (diff < smallestTimeDiff && diff <= 10000) { // 10-second tolerance
          smallestTimeDiff = diff;
          bestMatch = item;
        }
      });

      return bestMatch ? localStorage.getItem(bestMatch.key) : null;
    } catch (error) {
      console.error('Failed to find image from localStorage:', error);
      return null;
    }
  };

  // Find image from device storage
  const findImageFromDeviceStorage = async (employeeId, targetUnixTime, status) => {
    try {

      // find file via name
      const fileName = `${employeeId}_${status}_${targetUnixTime}`;
      
      
      // Get all files in the directory
      const files = [];
      for await (const [name, handle] of deviceStorageHandle.entries()) {
        if (name.startsWith(IMAGE_STORAGE_PREFIX) && name.includes(fileName)) {
          files.push({ name, handle });
        }
      }
      
      
      if (files.length === 0) return null;
      
      // Find exact or closest matching file based on Unix timestamp
      let bestMatch = null;
      let smallestTimeDiff = Infinity;
      
      files.forEach(file => {
        // Parse filename: qr_scan_images_employeeId_status_unixTime.jpg
        const parts = file.name.replace(IMAGE_STORAGE_PREFIX, '').replace('.jpg', '').split('_');
        if (parts.length >= 3) {
          const fileEmployeeId = parts[0];
          const fileStatus = parts[1];
          const fileUnixTime = parts[2];
          
          
          if (fileEmployeeId === employeeId && fileStatus === status && fileUnixTime) {
            // Direct Unix timestamp comparison (raw to raw)
            const timeDiff = Math.abs(targetUnixTime - fileUnixTime);
            
            // Check for exact match first, then allow small tolerance for timing differences
            if (timeDiff === 0 || (timeDiff < smallestTimeDiff && timeDiff <= 5000)) { // 5 second tolerance
              smallestTimeDiff = timeDiff;
              bestMatch = file;
              
            }
          }
        }
      });
      
      if (bestMatch) {
        // Read the file and convert to data URL
        const file = await bestMatch.handle.getFile();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            resolve(e.target.result);
          };
          reader.onerror = (e) => {
            console.error(`Failed to read image file: ${bestMatch.name}`, e);
            reject(e);
          };
          reader.readAsDataURL(file);
        });
      }
      
      return null;
    } catch (error) {
      console.error('Failed to find image from device storage:', error);
      return null;
    }
  };

  // Get device icon component
  const getDeviceIcon = () => {
    switch (deviceInfo.type) {
      case 'android':
        return AndroidIcon;
      case 'ios':
        return PhoneIphoneIcon;
      default:
        return LanguageIcon;
    }
  };

  // Device detection function
  const detectDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isStandalone = window.navigator.standalone === true;
    const isStandaloneChrome = window.matchMedia('(display-mode: standalone)').matches;
    const isPWA = isStandalone || isStandaloneChrome;
    
    let deviceType = 'web';
    
    if (/android/.test(userAgent)) {
      deviceType = 'android';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      deviceType = 'ios';
    }
    
    return {
      type: deviceType,
      isPWA,
      userAgent: navigator.userAgent
    };
  };

  // Camera switching function
  const toggleCamera = async () => {
    if (cameraActive) {
      // Stop current camera first
      setIsCameraLoading(false);
      setCameraActive(false);
      
      // Switch facing mode
      const newFacingMode = facingMode === 'environment' ? 'user' : 'environment';
      setFacingMode(newFacingMode);
      
      // Restart camera with new facing mode after a short delay
      setTimeout(() => {
        setIsCameraLoading(true);
        setCameraActive(true);
        setScanMessage(`Switching to ${newFacingMode === 'environment' ? 'back' : 'front'} camera...`);
        
        // Set loading state for camera switch
        setTimeout(() => {
          setIsCameraLoading(false);
          setScanMessage(`Switched to ${newFacingMode === 'environment' ? 'back' : 'front'} camera`);
        }, 2000);
      }, 500);
    } else {
      // Just switch the mode if camera is not active
      const newFacingMode = facingMode === 'environment' ? 'user' : 'environment';
      setFacingMode(newFacingMode);
    }

  };

  // Mirror toggle function
  const toggleMirror = () => {
    const newMirrorState = !isMirrored;
    setIsMirrored(newMirrorState);
    localStorage.setItem(MIRROR_PREFERENCE_KEY, JSON.stringify(newMirrorState));
    setScanMessage(`Camera view ${newMirrorState ? 'mirrored' : 'normal'}`);
  };

  // Load mirror preference from localStorage
  const loadMirrorPreference = () => {
    try {
      const savedPreference = localStorage.getItem(MIRROR_PREFERENCE_KEY);
      if (savedPreference !== null) {
        const mirrorState = JSON.parse(savedPreference);
        setIsMirrored(mirrorState);
      }
    } catch (error) {
      console.error('Failed to load mirror preference:', error);
      setIsMirrored(true); // Fallback to default
    }
  };

  // Load always-on preference from localStorage
  const loadAlwaysOnPreference = () => {
    try {
      const savedPreference = localStorage.getItem(ALWAYS_ON_PREFERENCE_KEY);
      if (savedPreference !== null) {
        const alwaysOnState = JSON.parse(savedPreference);
        setAlwaysOnMode(alwaysOnState);
      }
    } catch (error) {
      console.error('Failed to load always-on preference:', error);
      setAlwaysOnMode(true); // Fallback to default (always on)
    }
  };

  // Auto-prompt for device storage reauthorization for returning users
  const autoPromptDeviceStorageReauth = async () => {
    const savedStorageMethod = localStorage.getItem(STORAGE_METHOD_KEY);
    const wasAuthorized = localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY);
    
    if (savedStorageMethod === 'deviceStorage' && wasAuthorized === 'true' && 'showDirectoryPicker' in window && !hasShownReauthPrompt) {
      // Show reauthorization dialog for returning users (only once per session)
      setTimeout(() => {
        setIsReauthDialogOpen(true);
        setHasShownReauthPrompt(true);
      }, 2000);
    }
  };

  // Manually trigger reauthorization dialog
  const showReauthDialog = () => {
    setIsReauthDialogOpen(true);
  };

  // Handle camera controls popover
  const handleControlsPopoverOpen = (event) => {
    setControlsAnchorEl(event.currentTarget);
  };

  const handleControlsPopoverClose = () => {
    setControlsAnchorEl(null);
  };

  const isControlsPopoverOpen = Boolean(controlsAnchorEl);

  // Handle initial storage choice dialog
  const handleInitialStorageChoice = async (choice) => {
    setIsInitialStorageChoiceOpen(false);
    
    if (choice === 'deviceStorage') {
      // User chose device storage - attempt authorization
      setStorageMethod('deviceStorage');
      localStorage.setItem(STORAGE_METHOD_KEY, 'deviceStorage');
      
      try {
        const authorized = await requestDeviceStorageAuthorization();
        if (!authorized) {
          // User cancelled folder selection - fall back to browser storage
          setStorageMethod('localStorage');
          localStorage.setItem(STORAGE_METHOD_KEY, 'localStorage');
          setStorageAuthorized(true);
          enqueueSnackbar('Switched to browser storage since folder selection was cancelled', { variant: 'info' });
        }
      } catch (error) {
        console.error('Device storage authorization failed:', error);
        setStorageMethod('localStorage');
        localStorage.setItem(STORAGE_METHOD_KEY, 'localStorage');
        setStorageAuthorized(true);
        enqueueSnackbar('Switched to browser storage due to error', { variant: 'warning' });
      }
    } else {
      // User chose browser storage
      setStorageMethod('localStorage');
      localStorage.setItem(STORAGE_METHOD_KEY, 'localStorage');
      setStorageAuthorized(true);
      enqueueSnackbar('Using browser storage for images', { variant: 'success' });
    }
  };

  // Handle reauthorization from dialog
  const handleReauthFromDialog = async () => {
    try {
      // Keep dialog open during authorization process
      const success = await requestDeviceStorageAuthorization();
      if (success) {
        setIsReauthDialogOpen(false);
        enqueueSnackbar('Welcome back! Device storage reauthorized successfully.', { 
          variant: 'success',
          autoHideDuration: 4000 
        });
      }
      // If authorization failed, dialog stays open for user to retry
    } catch (error) {
      console.error('Error during reauthorization:', error);
      enqueueSnackbar('Failed to reauthorize device storage', { variant: 'error' });
    }
  };

  // Load storage preferences from localStorage
  const loadStoragePreferences = () => {
    try {
      const savedStorageMethod = localStorage.getItem(STORAGE_METHOD_KEY);

      // ------------------------------------------------------------------
      // 1. If the user has a previously-saved preference, honour it
      // ------------------------------------------------------------------
      if (savedStorageMethod) {
        setStorageMethod(savedStorageMethod);

        if (savedStorageMethod === 'deviceStorage') {
          // We used device storage before – verify / re-authorize
          checkDeviceStorageAuthorization();
          autoPromptDeviceStorageReauth();
        } else {
          // Browser storage needs no extra setup
          setStorageAuthorized(true);
        }
        return;
      }

      // ------------------------------------------------------------------
      // 2. First-time visitors → default to deviceStorage and prompt setup
      // ------------------------------------------------------------------
      // Show the initial storage choice dialog instead of immediately requesting folder
      setIsInitialStorageChoiceOpen(true);
      // Don't set any storage method yet - let the user choose via dialog
    } catch (error) {
      console.error('Failed to load storage preferences:', error);
      // Absolute fallback → browser storage
      setStorageMethod('localStorage');
      setStorageAuthorized(true);
    }
  };

  // Check if device storage is authorized
  const checkDeviceStorageAuthorization = async () => {
    try {
      if ('showDirectoryPicker' in window) {
        // Check if user has previously authorized device storage
        const wasAuthorized = localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY);
        const savedFolderName = localStorage.getItem(DEVICE_STORAGE_FOLDER_NAME_KEY);
        
        if (wasAuthorized === 'true') {
          // User has authorized before, but we need to prompt for folder selection again
          // due to File System Access API security restrictions
          setStorageAuthorized(false);
          setDeviceStorageHandle(null);
          
        } else {
          // First time user
          setStorageAuthorized(false);
          setDeviceStorageHandle(null);
        }
      } else {
        // For download fallback, always authorized
        setStorageAuthorized(true);
      }
    } catch (error) {
      console.error('Failed to check device storage authorization:', error);
      setStorageAuthorized(false);
    }
  };

  // Request device storage authorization
  const requestDeviceStorageAuthorization = async () => {
    if (isAuthorizingStorage) return false; // Prevent multiple simultaneous requests
    
    setIsAuthorizingStorage(true);
    try {
      if ('showDirectoryPicker' in window) {
        const directoryHandle = await window.showDirectoryPicker({
          mode: 'readwrite',
          startIn: 'pictures'
        });
        
        setDeviceStorageHandle(directoryHandle);
        setStorageAuthorized(true);
        
        // Check if this was a reauthorization before storing new values
        const wasAuthorized = localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY) === 'true';
        
        // Store authorization status and folder info in localStorage
        localStorage.setItem(DEVICE_STORAGE_AUTHORIZED_KEY, 'true');
        localStorage.setItem(DEVICE_STORAGE_FOLDER_NAME_KEY, directoryHandle.name || 'Selected Folder');
        
        if (wasAuthorized) {
          enqueueSnackbar('Device storage reauthorized successfully!', { variant: 'success' });
        } else {
          enqueueSnackbar('Device storage authorized successfully!', { variant: 'success' });
        }
        
        return true;
      } else {
        // For browsers without File System Access API, use download fallback
        setStorageAuthorized(true);
        localStorage.setItem(DEVICE_STORAGE_AUTHORIZED_KEY, 'true');
        localStorage.setItem(DEVICE_STORAGE_FOLDER_NAME_KEY, 'Downloads');
        enqueueSnackbar('Images will be downloaded to your default download folder', { variant: 'info' });
        
        return true;
      }
    } catch (error) {
      console.error('Failed to authorize device storage:', error);
      if (error.name === 'AbortError') {
        enqueueSnackbar('Storage authorization cancelled', { variant: 'warning' });
      } else {
        enqueueSnackbar('Failed to authorize device storage', { variant: 'error' });
      }
      setStorageAuthorized(false);
      return false;
    } finally {
      setIsAuthorizingStorage(false);
    }
  };

  // Change storage method
  const changeStorageMethod = async (method) => {
    try {
      setStorageMethod(method);
      localStorage.setItem(STORAGE_METHOD_KEY, method);
      
      if (method === 'deviceStorage') {
        // Check if user has previously authorized device storage
        const wasAuthorized = localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY);
        
        if (wasAuthorized === 'true') {
          // User has authorized before, prompt for reauthorization
          const savedFolderName = localStorage.getItem(DEVICE_STORAGE_FOLDER_NAME_KEY);
          enqueueSnackbar(
            `Please reselect your storage folder${savedFolderName ? ` (previously: ${savedFolderName})` : ''}`, 
            { variant: 'info' }
          );
        }
        
        // Don't close dialog during authorization process
        const authResult = await requestDeviceStorageAuthorization();
        if (!authResult) {
          // If authorization failed, revert to localStorage
          setStorageMethod('localStorage');
          localStorage.setItem(STORAGE_METHOD_KEY, 'localStorage');
          setStorageAuthorized(true);
        }
      } else {
        setStorageAuthorized(true);  // localStorage is always available
        setDeviceStorageHandle(null);
        // Clear device storage authorization data when switching to localStorage
        localStorage.removeItem(DEVICE_STORAGE_AUTHORIZED_KEY);
        localStorage.removeItem(DEVICE_STORAGE_FOLDER_NAME_KEY);
        enqueueSnackbar('Storage method changed to Browser Storage', { variant: 'info' });
      }
    } catch (error) {
      console.error('Failed to change storage method:', error);
      enqueueSnackbar('Failed to change storage method', { variant: 'error' });
      // Revert to localStorage on error
      setStorageMethod('localStorage');
      localStorage.setItem(STORAGE_METHOD_KEY, 'localStorage');
      setStorageAuthorized(true);
    }
  };

  // Toggle always-on mode function
  const toggleAlwaysOnMode = () => {
    const newAlwaysOnState = !alwaysOnMode;
    setAlwaysOnMode(newAlwaysOnState);
    localStorage.setItem(ALWAYS_ON_PREFERENCE_KEY, JSON.stringify(newAlwaysOnState));
    
    if (newAlwaysOnState) {
      // If switching to always-on mode, start camera if it's not active
      if (!cameraActive && !isCameraLoading) {
        startCamera();
      }
      setScanMessage(`Camera mode: Always On - Camera will stay active`);
    } else {
      // If switching to manual mode, stop camera and show manual message
      if (cameraActive || isCameraLoading) {
        stopCamera();
      }
      setScanMessage(`Camera mode: Manual - Click to start/stop camera`);
    }
  };

  // Get camera info for display
  const getCameraInfo = () => {
    return {
      current: facingMode === 'environment' ? 'Back Camera' : 'Front Camera',
      next: facingMode === 'environment' ? 'Front Camera' : 'Back Camera'
    };
  };

  // Check camera permissions
  const checkCameraPermissions = async () => {
    try {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // First, try to get basic camera access to trigger permission request
        try {
          // Request camera permission by attempting to access it
          const stream = await navigator.mediaDevices.getUserMedia({ 
            video: { facingMode: { ideal: 'user' } }
          });
          
          // Stop the stream immediately as we just need permission
          stream.getTracks().forEach(track => track.stop());
          
          // Now enumerate devices with proper permissions
          if (navigator.mediaDevices.enumerateDevices) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            
            // Check if we have both front and back cameras
            const hasMultipleCameras = videoDevices.length > 1;
            
            // Try to detect if we have both front and back cameras
            // by attempting to access both facing modes
            let actualCameraCount = videoDevices.length;
            
            // Additional check for mobile devices - try both facing modes
            if (videoDevices.length >= 2) {
              try {
                // Test back camera
                const backStream = await navigator.mediaDevices.getUserMedia({ 
                  video: { facingMode: { exact: 'environment' } } 
                });
                backStream.getTracks().forEach(track => track.stop());
                
                // Test front camera
                const frontStream = await navigator.mediaDevices.getUserMedia({ 
                  video: { facingMode: { exact: 'user' } } 
                });
                frontStream.getTracks().forEach(track => track.stop());
                
              } catch (facingModeError) {
                console.error('Some camera constraints failed, but multiple devices detected:', facingModeError.message);
              }
            }
            
            return {
              hasCamera: videoDevices.length > 0,
              hasMultipleCameras,
              deviceCount: actualCameraCount
            };
          }
          
          return { hasCamera: true, hasMultipleCameras: false, deviceCount: 1 };
          
        } catch (permissionError) {
          console.warn('Camera permission denied or not available:', permissionError);
          
          // Fallback: try without requesting permission first (limited info)
          if (navigator.mediaDevices.enumerateDevices) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            
            return {
              hasCamera: videoDevices.length > 0,
              hasMultipleCameras: videoDevices.length > 1,
              deviceCount: videoDevices.length,
              permissionDenied: true
            };
          }
          
          return { hasCamera: false, hasMultipleCameras: false, deviceCount: 0, permissionDenied: true };
        }
      }
      return { hasCamera: false, hasMultipleCameras: false, deviceCount: 0 };
    } catch (error) {
      console.warn('Camera permission check failed:', error);
      return { hasCamera: false, hasMultipleCameras: false, deviceCount: 0 };
    }
  };

  // Re-check cameras after camera is started (when permission is definitely granted)
  const recheckCamerasAfterPermission = async () => {
    try {
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        
        const hasMultipleCameras = videoDevices.length > 1;
        
        // Update device info if we found more cameras
        setDeviceInfo(prev => ({
          ...prev,
          hasCamera: videoDevices.length > 0,
          hasMultipleCameras,
          deviceCount: videoDevices.length,
          permissionDenied: false
        }));
        
        if (hasMultipleCameras && !deviceInfo.hasMultipleCameras) {
          setScanMessage('Multiple cameras detected! You can now switch between front and back cameras.');
        }
      }
    } catch (error) {
      console.warn('Failed to re-check cameras:', error);
    }
  };

  // Enhanced device detection with camera capabilities
  const detectDeviceAndCamera = async () => {
    const basicDevice = detectDevice();
    const cameraInfo = await checkCameraPermissions();
    
    return {
      ...basicDevice,
      ...cameraInfo
    };
  };

  // Static employee data for demonstration
  const employeeData = {
    'EMP001': {
      name: 'John Doe',
      position: 'Sales Associate'
    },
    'EMP002': {
      name: 'Jane Smith',
      position: 'Store Manager'
    },
    'EMP003': {
      name: 'Mike Johnson',
      position: 'Cashier'
    }
  };

  const timeButtons = [
    { id: 'time-in', label: 'Time In', icon: React.createElement(PlayArrowIcon), className: 'time-in' },
    { id: 'break-in', label: 'Break In', icon: React.createElement(PauseIcon), className: 'break-in' },
    { id: 'break-out', label: 'Break Out', icon: React.createElement(PlayArrowIcon), className: 'break-out' },
    { id: 'time-out', label: 'Time Out', icon: React.createElement(ExitToAppIcon), className: 'time-out' }
  ];

  // Detect device and camera capabilities on component mount
  useEffect(() => {
    const initializeDevice = async () => {
      const device = await detectDeviceAndCamera();
      setDeviceInfo(device);
    };
    
    // Load preferences from localStorage
    loadMirrorPreference();
    loadAlwaysOnPreference();
    loadStoragePreferences();
    
    initializeDevice();
  }, []);

  // Update current time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Load user, configure stores for admins
  useEffect(() => {
    const loadUserAndConfig = async () => {
      const local_user = await storage.getUser();
      if (!local_user) return;
      const userData = await JSON.parse(local_user);
      setUser(userData);

      // The scanner station name should always be the user's assigned company
      setStoreName(userData.company);

      if (userData.role >= 3) {
        try {
          const storesRes = await user_api.get_group_store(userData._id);
          if (storesRes && storesRes.status === 200 && storesRes.data?.report?.store) {
            const stores = storesRes.data.report.store;
            const sortedStores = stores
              .slice()
              .sort((a, b) => a.trim().replace(/\s+/g, ' ').localeCompare(b.trim().replace(/\s+/g, ' ')));
            setGroupStores(sortedStores);
            const initialStore = sortedStores.includes(userData.company) ? userData.company : sortedStores[0] || '';
            setSelectedStore(initialStore);
          } else {
            setGroupStores([userData.company]);
            setSelectedStore(userData.company);
          }
        } catch (err) {
          console.error('Error fetching group stores', err);
          setGroupStores([userData.company]);
          setSelectedStore(userData.company);
        }
      } else {
        setSelectedStore(userData.company);
      }
    };
    loadUserAndConfig();
  }, []); // Run once on mount

  // Fetch records whenever the selected store changes
  useEffect(() => {
    if (selectedStore && storageAuthorized) {
      fetchTodaysRecords(selectedStore);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStore, storageAuthorized]);

  // Separate useEffect for always-on camera handling
  useEffect(() => {
    if (user && alwaysOnMode) {
      // Only start camera if component is fully mounted and user is loaded
      const timeoutId = setTimeout(() => {
        if (!cameraActive && !isCameraLoading) { // Only start if camera isn't already active or loading
          startCamera();
        }
      }, 1000); // Small delay to ensure component is fully mounted
      
      return () => clearTimeout(timeoutId); // Clean up timeout
    }
  }, [alwaysOnMode, user]) // Only depend on alwaysOnMode and user, not everything else

  // Fetch today's records from backend
  const fetchTodaysRecords = async (company) => {
    try {
      setIsLoadingRecords(true)
      const today = moment().format('YYYY-MM-DD')
      const data = {
        store: company
      }
      
      const result = await user_api.get_record_bystore(data, today)
      
      if (result && result.data) {
        setRealTimeRecords(result.data.records || [])
        setTotalRecordsCount(result.data.count || 0)
        
        // Transform backend data to match existing log format for compatibility
        const transformedLogs = await transformBackendDataToLogs(result.data.records || [])
        setTimeLogs(transformedLogs)
      }
    } catch (error) {
      console.error('Error fetching today\'s records:', error)
      enqueueSnackbar('Failed to load today\'s records', {variant: 'error'})
    } finally {
      setIsLoadingRecords(false)
    }
  }

  // Transform backend data to existing log format
  const transformBackendDataToLogs = async (records) => {
    const logs = []
    
    for (const record of records) {
      if (record.Records && record.Records.length > 0) {
        for (const rec of record.Records) {
          if (rec.record && rec.record.length > 0) {
            for (const timeRecord of rec.record) {
              // Include all time-keeping records: time-in, break-in, break-out, time-out
              if (['time-in', 'break-in', 'break-out', 'time-out'].includes(timeRecord.status)) {
                const recordTimestamp = new Date(timeRecord.time).toISOString();
                
                
                // Use raw Unix timestamp directly for image matching
                const storedImage = await findImageByEmployeeAndTime(record.Employee._id, timeRecord.time, timeRecord.status);
                
                logs.push({
                  id: `${rec._id}_${timeRecord.status}_${timeRecord.time}`,
                  employeeId: record.Employee._id,
                  employeeName: record.Employee.displayName,
                  employeePosition: 'Staff Member', // Backend doesn't provide position
                  mode: timeRecord.status,
                  timestamp: recordTimestamp,
                  qrCode: `EMP_${record.Employee._id}`,
                  unixTime: timeRecord.time,
                  capturedPhoto: storedImage || generatePlaceholderPhoto(record.Employee.displayName, `EMP_${record.Employee._id}`),
                  isPlaceholder: !storedImage
                })
              }
            }
          }
        }
      }
    }
    
    // Sort by timestamp descending (newest first)
    return logs.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
  }

  // Get mode-specific statistics from real backend data
  const getModeStatsFromBackend = (mode) => {
    if (!realTimeRecords || realTimeRecords.length === 0) {
      return {
        title: `${getModeLabel(mode)} Today`,
        count: 0,
        subtitle: '0 total entries',
        color: '#4caf50'
      }
    }

    const today = new Date().toDateString()
    const modeCount = realTimeRecords.filter(record => {
      if (record.Records && record.Records.length > 0) {
        return record.Records.some(rec => {
          if (rec.record && rec.record.length > 0) {
            return rec.record.some(timeRecord => {
              const recordDate = new Date(timeRecord.time).toDateString()
              return timeRecord.status === mode && recordDate === today
            })
          }
          return false
        })
      }
      return false
    }).length

    // Get mode-specific titles and colors
    const getModeConfig = (mode) => {
      switch (mode) {
        case 'time-in':
          return {
            title: 'Employees Clocked In Today',
            subtitle: `${modeCount} total check-ins`,
            color: '#4caf50'
          }
        case 'break-in':
          return {
            title: 'Employees on Break Today',
            subtitle: `${modeCount} total break-ins`,
            color: '#ff9800'
          }
        case 'break-out':
          return {
            title: 'Break Returns Today',
            subtitle: `${modeCount} total break-outs`,
            color: '#2196f3'
          }
        case 'time-out':
          return {
            title: 'Employees Clocked Out Today',
            subtitle: `${modeCount} total check-outs`,
            color: '#f44336'
          }
        default:
          return {
            title: `${getModeLabel(mode)} Today`,
            subtitle: `${modeCount} total entries`,
            color: '#666'
          }
      }
    }

    const config = getModeConfig(mode)
    return {
      title: config.title,
      count: modeCount,
      subtitle: config.subtitle,
      color: config.color
    }
  }

  // Update getModeStats to use backend data for all modes
  const getModeStats = () => {
    // Use backend data for all modes
    const backendStats = getModeStatsFromBackend(selectedMode)
    const filteredLogs = getFilteredLogs()
    
    return {
      total: filteredLogs.length,
      today: filteredLogs.length, // All logs are from today
      percentage: totalRecordsCount > 0 ? Math.round((filteredLogs.length / totalRecordsCount) * 100) : 0,
      timeStats: backendStats
    }
  };

  // Generate placeholder photo function (moved earlier to avoid reference issues)
  const generatePlaceholderPhoto = (employeeName, qrCode) => {
    const canvas = canvasRef.current;
    if (!canvas) return null;
    
    const context = canvas.getContext('2d');
    canvas.width = 400;
    canvas.height = 300;
    
    // Create a gradient background
    const gradient = context.createLinearGradient(0, 0, canvas.width, canvas.height);
    gradient.addColorStop(0, '#2196F3');
    gradient.addColorStop(1, '#1976d2');
    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);
    
    // Add employee initial as a large circle
    const initial = employeeName.charAt(0).toUpperCase();
    context.fillStyle = 'rgba(255, 255, 255, 0.2)';
    context.beginPath();
    context.arc(canvas.width / 2, canvas.height / 2 - 30, 50, 0, 2 * Math.PI);
    context.fill();
    
    // Add initial text
    context.fillStyle = '#fff';
    context.font = 'bold 40px Arial';
    context.textAlign = 'center';
    context.fillText(initial, canvas.width / 2, canvas.height / 2 - 20);
    
    // Add employee name
    context.font = 'bold 16px Arial';
    context.fillText(employeeName, canvas.width / 2, canvas.height / 2 + 40);
    
    // Add timestamp
    context.font = '12px Arial';
    context.fillText(new Date().toLocaleString(), canvas.width / 2, canvas.height / 2 + 60);
    
    // Add QR code info
    context.font = '10px Arial';
    context.fillText(`QR: ${qrCode.substring(0, 20)}...`, canvas.width / 2, canvas.height / 2 + 80);
    
    return canvas.toDataURL('image/jpeg', 0.8);
  };

  // Refresh records after successful time-keeping action
  const refreshRecordsAfterTimeIn = async () => {
    if (user && user.company) {
      await fetchTodaysRecords(user.company)
    }
  }

  // Handle mode change and reset pagination
  const handleModeChange = (mode) => {
    setSelectedMode(mode)
    setRecordsPage(0) // Reset to first page when changing mode
  }

  // Helper: check if a location is valid (not 0,0)
  const isValidLocation = (loc) => {
    if (!loc) return false;
    const { latitude, longitude } = loc;
    return (
      typeof latitude === 'number' && typeof longitude === 'number' &&
      !(latitude === 0 && longitude === 0)
    );
  };

  // Quick geo-lookup: fast, low-accuracy, short timeout
  const quickGeolocation = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error('Geolocation not supported'));
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude });
      },
      reject,
      { enableHighAccuracy: false, timeout: 5000, maximumAge: 60000 }
    );
  });

  // Ensure we have a valid location before hitting the API
  const ensureLocation = async () => {
    // 1) Use previously cached location if still valid
    if (isValidLocation(location)) return location;

    // 2) Try quick lookup first (fast)
    try {
      const quickLoc = await quickGeolocation();
      if (isValidLocation(quickLoc)) {
        setLocation(quickLoc);
        ls.set('latitude', quickLoc.latitude.toString());
        ls.set('longitude', quickLoc.longitude.toString());
        return quickLoc;
      }
    } catch (_) {
      /* ignore – will fall back to full geolocation */
    }

    // 3) Fallback to the original high-accuracy function (may take longer)
    return await geolocation();
  };

  // ======== modify startCamera to pre-fetch location ========
  // ... existing code ...
  const startCamera = () => {
    setIsCameraLoading(true);
    setCameraActive(true);
    const modeText = alwaysOnMode ? ' (Always On)' : '';
    setScanMessage(`Starting camera...${modeText}`);

    // Pre-fetch location in the background so it is ready when we need it
    ensureLocation().catch((e) => console.warn('Quick geo pre-fetch failed:', e.message));

    // Simulate camera initialization time and then check if camera is ready
    setTimeout(() => {
      setIsCameraLoading(false);
      setScanMessage(`Scanning with ${getCameraInfo().current}...${modeText}`);

      // Re-check cameras after camera is fully initialized
      recheckCamerasAfterPermission();
    }, 2000); // Give camera 2 seconds to initialize
  };
  // ... existing code ...

  const stopCamera = () => {
    setIsCameraLoading(false);
    setCameraActive(false);
    const modeText = alwaysOnMode ? ' (Always On mode - will restart automatically)' : '';
    setScanMessage(`Click camera to start scanning${modeText}`);
  };

  const capturePhoto = () => {
    if (canvasRef.current) {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      
      // Set canvas dimensions
      canvas.width = 400;
      canvas.height = 300;
      
      // Try to find the video element within the QrReader component
      const qrReaderElement = videoRef.current;
      let videoElement = null;
      
      if (qrReaderElement) {
        // Look for video element inside the QrReader component
        videoElement = qrReaderElement.querySelector('video');
        
        // Alternative way to access video if the above doesn't work
        if (!videoElement && qrReaderElement.children) {
          for (let child of qrReaderElement.children) {
            const video = child.querySelector('video');
            if (video) {
              videoElement = video;
              break;
            }
          }
        }
      }
      
      if (videoElement && videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
        // Calculate aspect ratio to maintain proportions
        const videoWidth = videoElement.videoWidth;
        const videoHeight = videoElement.videoHeight;
        const aspectRatio = videoWidth / videoHeight;
        
        let drawWidth = canvas.width;
        let drawHeight = canvas.height;
        
        if (aspectRatio > (canvas.width / canvas.height)) {
          drawHeight = canvas.width / aspectRatio;
        } else {
          drawWidth = canvas.height * aspectRatio;
        }
        
        const offsetX = (canvas.width - drawWidth) / 2;
        const offsetY = (canvas.height - drawHeight) / 2;
        
        // Clear canvas
        context.fillStyle = '#000';
        context.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw the video frame
        context.drawImage(videoElement, offsetX, offsetY, drawWidth, drawHeight);
        
        return canvas.toDataURL('image/jpeg', 0.8);
      } else {
        // Fallback: create a demo photo with timestamp
        context.fillStyle = '#4CAF50';
        context.fillRect(0, 0, canvas.width, canvas.height);
        
        // Add some visual elements to make it look like a captured photo
        context.fillStyle = '#fff';
        context.font = 'bold 20px Arial';
        context.textAlign = 'center';
        context.fillText('📷 Photo Captured', canvas.width / 2, canvas.height / 2 - 20);
        
        context.font = '14px Arial';
        context.fillText(new Date().toLocaleString(), canvas.width / 2, canvas.height / 2 + 10);
        
        // Add a simple frame effect
        context.strokeStyle = '#fff';
        context.lineWidth = 3;
        context.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);
        
        return canvas.toDataURL('image/jpeg', 0.8);
      }
    }
    return null;
  };

  const geolocation = async () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const newLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            setLocation(newLocation); // Update component state
            ls.set('latitude', newLocation.latitude.toString()); // Store in SecureLS
            ls.set('longitude', newLocation.longitude.toString()); // Store in SecureLS
            resolve(newLocation);
          },
          (error) => {
            alert("Please turn on location services and try again." + error)
            console.error("Error getting location: ", error);
            const lat = ls.get('latitude');
            const long = ls.get('longitude');
            if (lat && long && parseFloat(lat) !== 0 && parseFloat(long) !== 0) {
              const cachedLocation = { latitude: parseFloat(lat), longitude: parseFloat(long) };
              setLocation(cachedLocation); // Update component state with cached
              resolve(cachedLocation); 
            } else {
              alert('Failed to get location. Please ensure location services are enabled, permissions are granted, and try refreshing.');
              reject(error);
            }
            return "error"
          },
          { enableHighAccuracy: true, timeout: 20000, maximumAge: 60000 } // Options: 20s timeout, allow cached for 1 min
        );
      } else {
        alert('Geolocation is not supported by this browser/WebView.');
        reject(new Error('Geolocation not supported'));
      }
    });
  };

  // ======== refactor handleUpdateStatus ========
  // ... existing code ...
  const handleUpdateStatus = async (data) => {
    try {
      // Note: setIsProcessing(true) is already handled in handleScan

      // 1) Ensure we have a valid geolocation first – abort early if impossible
      let currentGeoLocation;
      try {
        currentGeoLocation = await ensureLocation();
      } catch (err) {
        enqueueSnackbar('Failed to get location. Please enable location and try again.', { variant: 'error' });
        return { status: 500, error: 'Geolocation failed' };
      }

      if (!isValidLocation(currentGeoLocation)) {
        alert('Could not obtain a valid location. Please enable location services and try again.');
        return { status: 500, error: 'Invalid geolocation (0,0)' };
      }

      if (!scanResult && !data._id) {
        alert('User data is not loaded. Please try again.');
        return { status: 500, error: 'User data not loaded' };
      }

      // 2) TIMING instrumentation – measure API latency (will log in dev-tools)
      const t0 = performance.now();
      const result = await user_api.post_user_status(selectedMode, currentGeoLocation, data.uid, data._id);

      if (!result.ok) {
        enqueueSnackbar(result.data.msg, { variant: 'error' });
        return { status: 500, error: result.data.msg };
      }

      if (result.data && typeof result.data.status !== 'undefined') {
        enqueueSnackbar(`${getModeLabel(selectedMode)} Success`, { variant: 'success' });
        return { status: 200, data: result.data };
      }

      const errorMsg = 'API response missing or invalid after status update.';
      enqueueSnackbar(errorMsg, { variant: 'error' });
      return { status: 500, error: errorMsg };
    } catch (error) {
      console.error('Error in handleUpdateStatus: ', error);
      enqueueSnackbar('Unexpected error while updating status.', { variant: 'error' });
      return { status: 500, error: error.message };
    }
  };
  // ... existing code ...

  const handleScan = async (data) => {
    // Ignore empty scans or additional scans while processing
    if (!data || isProcessing) return;

    setScanResult(data);

    // Capture the frame BEFORE we hide the camera so the <video> is still available
    const capturedPhoto = capturePhoto();

    // Show the processing overlay + message and disable further scans
    setIsProcessing(true);
    setScanMessage(`Processing ${getModeLabel(selectedMode)} for QR: ${data.substring(0, 15)}...`);

    // Derive the employeeId from the QR value (fall-back logic for demo data)
    const employeeId = data.includes('EMP') ? data : `EMP${Math.floor(Math.random() * 900) + 100}`;

    try {
      if (employeeData[employeeId] || data.includes('EMP')) {
        await handleTimeKeeping(employeeId, data, capturedPhoto);
      } else {
        const demoEmployee = {
          name: `Employee ${employeeId}`,
          position: 'Staff Member'
        };
        await handleTimeKeeping(employeeId, data, capturedPhoto, demoEmployee);
      }
    } finally {
      // Hide processing overlay & decide what to do with the camera next
      setIsProcessing(false);

      if (alwaysOnMode) {
        // Camera stays active – reset the message for the next scan
        setScanMessage(`Scanning with ${getCameraInfo().current}... (Always On)`);
      } else {
        // Stop camera in manual mode
        stopCamera();
      }
    }
  };

  const handleError = (err) => {
    console.error('QR Scan Error:', err);
    
    // Stop loading state on error
    setIsCameraLoading(false);
    
    // Enhanced error handling based on device type
    let errorMessage = 'Camera error. Please check permissions.';
    
    if (err.name === 'NotAllowedError') {
      errorMessage = 'Camera permission denied. Please allow camera access.';
    } else if (err.name === 'NotFoundError') {
      errorMessage = 'No camera found. Please check your device.';
    } else if (err.name === 'NotReadableError') {
      errorMessage = 'Camera is already in use by another application.';
    } else if (err.name === 'OverconstrainedError') {
      errorMessage = `Camera constraint error. Trying to switch to ${facingMode === 'environment' ? 'front' : 'back'} camera.`;
      // Automatically try the other camera
      setTimeout(() => {
        toggleCamera();
      }, 2000);
    }
    
    setScanMessage(errorMessage);
  };

  const renderTime = (_time) => {
    let _date = new Date(_time)
    /*    var hours = _date.getHours()
        var minutes = _date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours ? hours : 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        const phTime = moment.tz(strTime, 'h:mm A', 'Asia/Manila')*/
    const userTimeZone = moment.tz.guess()
    const userLocalTime = _date.toLocaleString('en-US', {timeZone: userTimeZone, hour: 'numeric', minute: '2-digit'})
    return userLocalTime
    //return strTime
  }

  const filterByStatus = (_data, type) => {
    let _d = _data.filter((_d) => (_d.status === type ? _d : ''))
    if (_d.length > 0) {
      _d = _d[0]
    }
    if (_d) {
      if (typeof _d.time === 'string') {
        return {
          time: _d.time === undefined ? 'n/a' : _d.time,
          _longitude: _d.location === undefined ? '' : _d.location.longitude,
          _latitude: _d.location === undefined ? 'n/a' : _d.location.latitude,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )',
        }
      } else {
        return {
          time: _d.time === undefined ? 'n/a' : renderTime(_d.time),
          _longitude: _d.location === undefined ? '' : _d.location.longitude,
          _latitude: _d.location === undefined ? 'n/a' : _d.location.latitude,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )',
        }
      }
    } else {
      return '-'
    }
  }

  const handleTimeKeeping = async (employeeId, qrCode, capturedPhoto, customEmployee = null) => {
    try {
      const employee = customEmployee || employeeData[employeeId];
      // If no photo was captured, generate a unique placeholder
      let finalPhoto = capturedPhoto;
      let imageKey
      let unixTime
      let currentTimestamp
      if (!capturedPhoto) {
        finalPhoto = generatePlaceholderPhoto(employee?.name || 'Employee', qrCode);
      }
      const result = await user_api.get_user_status(qrCode)
      const resultv2 = await user_api.get_limited_users(qrCode)
      const timeOut = filterByStatus(result.data[0].record, 'time-out').time
      const timeIn = filterByStatus(result.data[0].record, 'time-in').time
      const breakin = filterByStatus(result.data[0].record, 'break-in').time
      const breakout = filterByStatus(result.data[0].record, 'break-out').time
      if(resultv2.data[0].status === "time-out" && selectedMode === "break-in") {
        alert(`Please time-in first`)
      }
      else if (resultv2.data[0].status === "time-in" && selectedMode === "break-out") {
        alert(`Please break-in first`)
      }
      else if (resultv2.data[0].status === "break-in" && selectedMode === "time-out") {
        alert(`Please break-out first`)
      }
      else if (resultv2.data[0].status === "time-out" && selectedMode === "time-out") {
        alert(`Please time-in first`)
      }
      else if (result.data[0].status !== "time-out" && selectedMode === "time-in") {
        alert(`Personnel already time-in`);
      }
      else if (breakin !== "n/a" && selectedMode === "break-in") {
        alert(`Personnel already break-in`);
      }
      else if (breakout !== "n/a" && selectedMode === "break-out") {
        alert(`Personnel already break-out`);
      }
      else if (timeOut !== "n/a" && selectedMode === "time-out") {
        alert(`Personnel already time-out`);
      }
      else {
        const statusResult = await handleUpdateStatus(result.data[0])
        // If status update was successful, store the captured photo
        if (statusResult && statusResult.status === 200) {
          const getLatestTimeLog = await user_api.get_user_status(qrCode)
          currentTimestamp = getLatestTimeLog.data[0].record[0].dateTime
          if (getLatestTimeLog.data[0].status !== "time-out" && selectedMode === "time-in") {
            // Store the captured photo with selected storage method
            if (capturedPhoto) {
                unixTime = getLatestTimeLog.data[0].record.filter((time) => time.status === "time-in")[0].time
                imageKey = await storeImage(qrCode, unixTime, "time-in", capturedPhoto);
            }
          }
          else if (getLatestTimeLog.data[0].status === "break-in" && selectedMode === "break-in") {
            // Store the captured photo with selected storage method
            if (capturedPhoto) {
              unixTime = getLatestTimeLog.data[0].record.filter((time) => time.status === "break-in")[0].time
              imageKey = await storeImage(qrCode, unixTime, "break-in", capturedPhoto);
            }
          }
          else if (getLatestTimeLog.data[0].status === "break-out" && selectedMode === "break-out") {
            // Store the captured photo with selected storage method
            if (capturedPhoto) {
              unixTime = getLatestTimeLog.data[0].record.filter((time) => time.status === "break-out")[0].time
              imageKey = await storeImage(qrCode, unixTime, "break-out", capturedPhoto);
            }
          }
          else if (getLatestTimeLog.data[0].status === "time-out" && selectedMode === "time-out") {
            // Store the captured photo with selected storage method
            if (capturedPhoto) {
              unixTime = getLatestTimeLog.data[0].record.filter((time) => time.status === "time-out")[0].time
              imageKey = await storeImage(qrCode, unixTime, "time-out", capturedPhoto);
            }
          } else {
            alert("Personnel already " + selectedMode)
          }
        }
      }
        const newLog = {
          id: `${qrCode}_${selectedMode}_${unixTime}`,
          employeeId: qrCode,
          employeeName: employee?.name || 'Unknown Employee',
          employeePosition: employee?.position || 'Unknown Position',
          mode: selectedMode,
          timestamp: currentTimestamp,
          qrCode: `EMP_${qrCode}`,
          capturedPhoto: finalPhoto
        };

        const updatedLogs = [newLog, ...timeLogs];
        localStorage.setItem('timeKeepingLogs', JSON.stringify(updatedLogs));
        await refreshRecordsAfterTimeIn()
    } catch (error) {
      console.error('Error in handleTimeKeeping:', error);
      alert('An error occurred while processing the QR code. Please try again.');
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour12: true, 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatLogTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const getModeLabel = (mode) => {
    switch (mode) {
      case 'time-in': return 'Time In';
      case 'break-in': return 'Break In';
      case 'break-out': return 'Break Out';
      case 'time-out': return 'Time Out';
      default: return mode;
    }
  };

  // Filter logs based on selected mode
  const getFilteredLogs = () => {
    return timeLogs.filter(log => log.mode === selectedMode);
  };

  // Download helper – builds same file name convention and triggers a download for data-URLs
  const downloadLogImage = (log) => {
    if (!log || !log.capturedPhoto) return;

    const cleanEmployeeId = (log.employeeId || '').replace('EMP_', '');
    const filename = `${IMAGE_STORAGE_PREFIX}${cleanEmployeeId}_${log.mode}_${log.unixTime || Date.now()}.jpg`;
    downloadImage(filename, log.capturedPhoto);
  };

  // After timeLogs update, attempt to fill in any placeholders with real images
  useEffect(() => {
    const replacePlaceholders = async () => {
      let updated = null;
      for (let i = 0; i < timeLogs.length; i++) {
        const log = timeLogs[i];
        if (log.isPlaceholder) {
          const img = await findImageByEmployeeAndTime(log.employeeId, log.unixTime, log.mode);
          if (img) {
            if (!updated) updated = [...timeLogs];
            updated[i] = { ...log, capturedPhoto: img, isPlaceholder: false };
          }
        }
      }
      if (updated) {
        setTimeLogs(updated);
      }
    };

    if (timeLogs && timeLogs.length) {
      // Fire and forget; no need to await inside effect cleanup
      replacePlaceholders();
    }
  }, [timeLogs]);

  // New handler for store selection
  const handleStoreChange = (event, newValue) => {
    setSelectedStore(newValue || '');
  };

  return (
    <>
      <Container 
        maxWidth="xl" 
        style={{ 
          paddingTop: isMobile ? 12 : 24, 
          // Leave space for single bottom navigation on mobile
          paddingBottom: isMobile ? 76 : 24,
          paddingLeft: isMobile ? 8 : undefined,
          paddingRight: isMobile ? 8 : undefined,
        }}
      >

        {/* Device Info Display */}
        <Box style={{ 
          marginBottom: isMobile ? 12 : 16, 
          padding: isMobile ? '6px 12px' : '8px 16px', 
          backgroundColor: '#f5f5f5', 
          borderRadius: isMobile ? 6 : 8,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? '4px' : '8px'
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {React.createElement(getDeviceIcon(), { 
              style: { 
                color: '#1976d2',
                fontSize: isMobile ? '1rem' : '1.25rem'
              } 
            })}
            <Typography variant={isMobile ? 'caption' : 'body2'} color="textSecondary">
              Device: {deviceInfo.type.toUpperCase()} 
              {deviceInfo.isPWA && ' (PWA)'}
            </Typography>
          </Box>
          {!isMobile && (
            <Typography variant="body2" color="textSecondary">
              {' | Camera: ' + getCameraInfo().current}
              {deviceInfo.hasCamera && ` | Cameras: ${deviceInfo.deviceCount || 1}`}
              {!deviceInfo.hasCamera && ' | No Camera Detected'}
              {deviceInfo.permissionDenied && ' | Permission Needed'}
              {` | View: ${isMirrored ? 'Mirrored' : 'Normal'}`}
              {` | Mode: ${alwaysOnMode ? 'Always On' : 'Manual'}`}
              {` | Storage: ${storageMethod === 'localStorage' ? 'Browser' : 'Device'}`}
              {` | ${storageAuthorized ? '✓' : '✗'}`}
            </Typography>
          )}
        </Box>

        {/* Hidden canvas for photo capture */}
        <canvas ref={canvasRef} style={{ display: 'none' }} />

        <Grid container spacing={isMobile ? 2 : 3}>
          {/* Left Section - QR Scanner */}
          {(!isMobile || mobileTab === 'scan') && (
          <Grid item xs={12} md={6}>
            <StyledCard2>
              <CardContent style={{ padding: isMobile ? 16 : 24 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '16px' : '24px' }}>
                  {/* Store Name & Controls Row */}
                  {isMobile ? (
                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}>
                      <Box style={{ flex: 2, textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                          {storeName}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Time Keeping Station
                        </Typography>
                      </Box>
                      <Divider orientation="vertical" flexItem style={{ border: '1px solid #1976d2' }} />
                      <Box style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Button
                          variant="outlined"
                          startIcon={<TuneIcon />}
                          onClick={handleControlsPopoverOpen}
                          size="small"
                          style={{
                            borderColor: '#1976d2',
                            color: '#1976d2',
                            textTransform: 'none',
                            fontSize: '0.8rem',
                            minHeight: 36,
                            minWidth: 100,
                          }}
                        >
                          Controls
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Box textAlign="center">
                      <Typography 
                        variant="h5" 
                        style={{ fontWeight: 'bold', color: '#1976d2' }}
                      >
                        {storeName}
                      </Typography>
                      <Typography 
                        variant="subtitle1" 
                        color="textSecondary"
                      >
                        Time Keeping Station
                      </Typography>
                    </Box>
                  )}

                  <Divider />

                  {/* Camera Controls */}
                  {!isMobile && (
                    /* Desktop View - All buttons visible */
                    <Box style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      flexDirection: 'row',
                      gap: '12px', 
                      marginBottom: 8 
                    }}>
                      {deviceInfo.hasMultipleCameras ? (
                        <Button
                          variant="outlined"
                          startIcon={<FlipCameraAndroidIcon />}
                          onClick={toggleCamera}
                          size="small"
                          style={{
                            borderColor: '#1976d2',
                            color: '#1976d2',
                            textTransform: 'none',
                            fontSize: '0.8rem'
                          }}
                        >
                          Switch to {getCameraInfo().next}
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          startIcon={<FlipCameraAndroidIcon />}
                          onClick={toggleCamera}
                          size="small"
                          disabled
                          style={{
                            borderColor: '#ccc',
                            color: '#999',
                            textTransform: 'none',
                            fontSize: '0.8rem'
                          }}
                          title="Only one camera available"
                        >
                          Single Camera Only
                        </Button>
                      )}
                      
                      {/* Mirror Toggle Button */}
                      <Button
                        variant={isMirrored ? "contained" : "outlined"}
                        onClick={toggleMirror}
                        size="small"
                        style={{
                          borderColor: '#4caf50',
                          color: isMirrored ? '#fff' : '#4caf50',
                          backgroundColor: isMirrored ? '#4caf50' : 'transparent',
                          textTransform: 'none',
                          fontSize: '0.8rem',
                          '&:hover': {
                            backgroundColor: isMirrored ? '#45a049' : '#f1f8e9',
                          }
                        }}
                        title={`Camera view is ${isMirrored ? 'mirrored' : 'normal'}`}
                      >
                        {isMirrored ? 'Mirrored' : 'Normal'}
                      </Button>
                      
                      {/* Always On Toggle Button */}
                      <Button
                        variant={alwaysOnMode ? "contained" : "outlined"}
                        onClick={toggleAlwaysOnMode}
                        size="small"
                        style={{
                          borderColor: '#ff9800',
                          color: alwaysOnMode ? '#fff' : '#ff9800',
                          backgroundColor: alwaysOnMode ? '#ff9800' : 'transparent',
                          textTransform: 'none',
                          fontSize: '0.8rem',
                          '&:hover': {
                            backgroundColor: alwaysOnMode ? '#f57c00' : '#fff3e0',
                          }
                        }}
                        title={`Camera is ${alwaysOnMode ? 'always on' : 'manual start/stop'}`}
                      >
                        {alwaysOnMode ? 'Always On' : 'Manual'}
                      </Button>
                      
                      {/* Storage Settings Button */}
                      <Button
                        variant="outlined"
                        startIcon={<SettingsIcon />}
                        onClick={() => setIsStorageSettingsOpen(true)}
                        size="small"
                        style={{
                          borderColor: storageAuthorized ? (storageMethod === 'localStorage' ? '#4caf50' : '#2196f3') : '#f44336',
                          color: storageAuthorized ? (storageMethod === 'localStorage' ? '#4caf50' : '#2196f3') : '#f44336',
                          backgroundColor: storageAuthorized ? 'transparent' : '#ffebee',
                          textTransform: 'none',
                          fontSize: '0.8rem',
                          '&:hover': {
                            backgroundColor: storageAuthorized ? '#eceff1' : '#ffcdd2',
                          }
                        }}
                        title={`Configure image storage settings - Current: ${storageMethod === 'localStorage' ? 'Browser Storage' : 'Device Storage'} (${storageAuthorized ? 'Authorized' : 'Not Authorized'})`}
                      >
                        Storage Settings {storageAuthorized ? '✓' : '✗'}
                      </Button>
                    </Box>
                  )}

                  {/* QR Scanner */}
                  <Box>
                    <Box style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      marginBottom: isMobile ? 12 : 16,
                      padding: isMobile ? 12 : 16,
                      border: '2px dashed #1976d2',
                      borderRadius: isMobile ? 6 : 8,
                      backgroundColor: '#f5f5f5'
                    }}>
                      {!cameraActive ? (
                        <CameraPlaceholder onClick={startCamera}>
                          <div style={{ textAlign: 'center', color: 'white' }}>
                            <IconButton style={{ 
                              color: 'white', 
                              fontSize: isMobile ? '3rem' : '4rem'
                            }}>
                              <CameraAltIcon style={{ 
                                fontSize: isMobile ? '3rem' : '4rem' 
                              }} />
                            </IconButton>
                            <Typography 
                              variant={isMobile ? "caption" : "body2"} 
                              style={{ marginTop: 8 }}
                            >
                              {getCameraInfo().current}
                            </Typography>
                            <Typography 
                              variant="caption" 
                              style={{ 
                                marginTop: 4, 
                                display: 'block',
                                opacity: 0.8
                              }}
                            >
                              {alwaysOnMode ? 'Always On Mode' : 'Tap to start scanning'}
                            </Typography>
                            <Typography 
                              variant="caption" 
                              style={{ 
                                marginTop: 2, 
                                display: 'block',
                                opacity: 0.6,
                                fontSize: isMobile ? '0.6rem' : '0.7rem'
                              }}
                            >
                              {alwaysOnMode ? 'Camera will start automatically' : 'Manual start/stop mode'}
                            </Typography>
                          </div>
                        </CameraPlaceholder>
                      ) : isCameraLoading ? (
                        <LoadingContainer>
                          <div style={{ textAlign: 'center', color: 'white', position: 'relative', zIndex: 1 }}>
                            <LoadingSpinner />
                            <Typography 
                              variant={isMobile ? "body2" : "h6"} 
                              style={{ 
                                marginBottom: 8,
                                fontSize: isMobile ? '1rem' : '1.2rem',
                                fontWeight: 'bold'
                              }}
                            >
                              Connecting Camera...
                            </Typography>
                            <Typography 
                              variant="caption" 
                              style={{ 
                                display: 'block',
                                opacity: 0.8,
                                fontSize: isMobile ? '0.8rem' : '0.9rem'
                              }}
                            >
                              {getCameraInfo().current}
                            </Typography>
                            <PulsingDots>
                              <div className="dot"></div>
                              <div className="dot"></div>
                              <div className="dot"></div>
                            </PulsingDots>
                          </div>
                        </LoadingContainer>
                      ) : isProcessing ? (
                        <LoadingContainer>
                          <div style={{ textAlign: 'center', color: 'white', position: 'relative', zIndex: 1 }}>
                            <LoadingSpinner />
                            <Typography 
                              variant={isMobile ? "body2" : "h6"} 
                              style={{ 
                                marginBottom: 8,
                                fontSize: isMobile ? '1rem' : '1.2rem',
                                fontWeight: 'bold'
                              }}
                            >
                              Processing QR Code...
                            </Typography>
                            <Typography 
                              variant="caption" 
                              style={{ 
                                display: 'block',
                                opacity: 0.8,
                                fontSize: isMobile ? '0.8rem' : '0.9rem'
                              }}
                            >
                              Please wait while we process your {getModeLabel(selectedMode).toLowerCase()}
                            </Typography>
                            <PulsingDots>
                              <div className="dot"></div>
                              <div className="dot"></div>
                              <div className="dot"></div>
                            </PulsingDots>
                          </div>
                        </LoadingContainer>
                      ) : (
                                                <Box 
                        style={{ 
                          width: '100%', 
                          maxWidth: isMobile ? '100%' : '550px', 
                          position: 'relative',
                          cursor: alwaysOnMode ? 'default' : 'pointer'
                        }}
                        onClick={alwaysOnMode ? undefined : stopCamera}
                        title={alwaysOnMode ? "Camera is in Always On mode" : "Click to stop camera"}
                      >
                        <div 
                          ref={videoRef}
                          style={{
                            transform: isMirrored ? 'scaleX(-1)' : 'scaleX(1)',
                            transition: 'transform 0.3s ease-in-out'
                          }}
                        >
                          <QrReader
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            onLoad={() => {
                              setIsCameraLoading(false);
                              const modeText = alwaysOnMode ? ' (Always On)' : '';
                              setScanMessage(`Scanning with ${getCameraInfo().current}...${modeText}`);
                            }}
                            constraints={{
                              facingMode: facingMode,
                              width: { ideal: isMobile ? 360 : 640 },
                              height: { ideal: isMobile ? 240 : 480 }
                            }}
                            style={{ width: '100%', height: '100%' }}
                          />
                        </div>
                        {isProcessing && (
                          <Box style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(76, 175, 80, 0.8)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 4
                          }}>
                            <Typography 
                              variant={isMobile ? "body1" : "h6"} 
                              style={{ color: 'white', fontWeight: 'bold' }}
                            >
                              📸 Photo Captured!
                            </Typography>
                          </Box>
                        )}
                        {/* Camera Info Overlay */}
                        <Box style={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          color: 'white',
                          padding: isMobile ? '3px 6px' : '4px 8px',
                          borderRadius: 4,
                          fontSize: isMobile ? '10px' : '12px',
                          fontWeight: 'bold',
                          pointerEvents: 'none'
                        }}>
                          {getCameraInfo().current} - {isMirrored ? 'Mirrored' : 'Normal'}
                        </Box>
                        {/* Stop Camera Overlay Hint */}
                        {!alwaysOnMode && (
                          <Box style={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            color: 'white',
                            padding: isMobile ? '3px 6px' : '4px 8px',
                            borderRadius: 4,
                            fontSize: isMobile ? '10px' : '12px',
                            fontWeight: 'bold',
                            pointerEvents: 'none'
                          }}>
                            Tap to stop
                          </Box>
                        )}
                        
                        {/* Always On Mode Indicator */}
                        {alwaysOnMode && (
                          <Box style={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            backgroundColor: 'rgba(255, 152, 0, 0.8)',
                            color: 'white',
                            padding: isMobile ? '3px 6px' : '4px 8px',
                            borderRadius: 4,
                            fontSize: isMobile ? '10px' : '12px',
                            fontWeight: 'bold',
                            pointerEvents: 'none'
                          }}>
                            Always On
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>

                  <Alert 
                    severity={scanResult ? "success" : cameraActive ? "info" : "info"} 
                    style={{ 
                      textAlign: 'center',
                      fontSize: isMobile ? '0.8rem' : undefined
                    }}
                  >
                    {scanMessage}
                  </Alert>

                  {/* Mobile: quick mode buttons under camera */}
                  {isMobile && (
                    <Box style={{ marginTop: 8 }}>
                      <Grid container spacing={1}>
                        {timeButtons.map((btn) => (
                          <Grid item xs={3} key={btn.id}>
                            <TimeButton
                              className={btn.className}
                              fullWidth
                              onClick={() => handleModeChange(btn.id)}
                              style={ selectedMode === btn.id ? {
                                opacity: 1,
                                transform: 'scale(1.05)',
                                border: '2px solid #333',
                                backgroundColor: '#2094F3',
                                fontSize: '0.875rem',
                                padding: '4px 2px',
                                minHeight: 38
                              } : {
                                opacity: 0.8,
                                border: '1px solid transparent',
                                fontSize: '0.875rem',
                                padding: '4px 2px',
                                minHeight: 38
                              }}
                            >
                              {btn.label}
                            </TimeButton>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                </Box>

                {/* Mobile Camera Controls Popover */}
                <Popover
                  open={isControlsPopoverOpen}
                  anchorEl={controlsAnchorEl}
                  onClose={handleControlsPopoverClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    style: {
                      padding: 16,
                      minWidth: 280,
                      maxWidth: 320
                    }
                  }}
                >
                  <Box style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <Typography variant="subtitle2" style={{ 
                      fontWeight: 'bold', 
                      marginBottom: 8,
                      textAlign: 'center',
                      color: '#666'
                    }}>
                      Camera Controls
                    </Typography>
                    
                    {/* Switch Camera Button */}
                    {deviceInfo.hasMultipleCameras && (<Button
                      variant="outlined"
                      startIcon={<FlipCameraAndroidIcon />}
                      onClick={() => {
                        toggleCamera();
                        handleControlsPopoverClose();
                      }}
                      fullWidth
                      style={{
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        minHeight: 44,
                      }}
                      title={`Switch to ${getCameraInfo().next}`}
                    >
                      {`Switch to ${getCameraInfo().next}`}
                    </Button>
                    )}
                    
                    {/* Mirror Toggle Button */}
                    <Button
                      variant={isMirrored ? "contained" : "outlined"}
                      onClick={() => {
                        toggleMirror();
                        handleControlsPopoverClose();
                      }}
                      fullWidth
                      style={{
                        borderColor: '#4caf50',
                        color: isMirrored ? '#fff' : '#4caf50',
                        backgroundColor: isMirrored ? '#4caf50' : 'transparent',
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        minHeight: 44,
                        '&:hover': {
                          backgroundColor: isMirrored ? '#45a049' : '#f1f8e9',
                        }
                      }}
                      title={`Camera view is ${isMirrored ? 'mirrored' : 'normal'}`}
                    >
                      {isMirrored ? '📱 Mirrored View' : '📱 Normal View'}
                    </Button>
                    
                    {/* Always On Toggle Button */}
                    <Button
                      variant={alwaysOnMode ? "contained" : "outlined"}
                      onClick={() => {
                        toggleAlwaysOnMode();
                        handleControlsPopoverClose();
                      }}
                      fullWidth
                      style={{
                        borderColor: '#ff9800',
                        color: alwaysOnMode ? '#fff' : '#ff9800',
                        backgroundColor: alwaysOnMode ? '#ff9800' : 'transparent',
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        minHeight: 44,
                        '&:hover': {
                          backgroundColor: alwaysOnMode ? '#f57c00' : '#fff3e0',
                        }
                      }}
                      title={`Camera is ${alwaysOnMode ? 'always on' : 'manual start/stop'}`}
                    >
                      {alwaysOnMode ? '🔄 Always On Mode' : '👆 Manual Mode'}
                    </Button>
                    
                    {/* Storage Settings Button */}
                    <Button
                      variant="outlined"
                      startIcon={<SettingsIcon />}
                      onClick={() => {
                        setIsStorageSettingsOpen(true);
                        handleControlsPopoverClose();
                      }}
                      fullWidth
                      style={{
                        borderColor: storageAuthorized ? (storageMethod === 'localStorage' ? '#4caf50' : '#2196f3') : '#f44336',
                        color: storageAuthorized ? (storageMethod === 'localStorage' ? '#4caf50' : '#2196f3') : '#f44336',
                        backgroundColor: storageAuthorized ? 'transparent' : '#ffebee',
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        minHeight: 44,
                        '&:hover': {
                          backgroundColor: storageAuthorized ? '#eceff1' : '#ffcdd2',
                        }
                      }}
                      title={`Configure image storage settings - Current: ${storageMethod === 'localStorage' ? 'Browser Storage' : 'Device Storage'} (${storageAuthorized ? 'Authorized' : 'Not Authorized'})`}
                    >
                      💾 Storage Settings {storageAuthorized ? '✓' : '✗'}
                    </Button>

                    <Divider style={{ margin: '8px 0' }} />

                    {/* Current Settings Display */}
                    <Box style={{ 
                      padding: 8, 
                      backgroundColor: '#f5f5f5', 
                      borderRadius: 4,
                      fontSize: '0.8rem'
                    }}>
                      <Typography variant="caption" style={{ fontWeight: 'bold', display: 'block' }}>
                        Current Settings:
                      </Typography>
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                        📷 View: {isMirrored ? 'Mirrored' : 'Normal'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                        🔄 Mode: {alwaysOnMode ? 'Always On' : 'Manual'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                        💾 Storage: {storageMethod === 'localStorage' ? 'Browser' : 'Device'} {storageAuthorized ? '✓' : '✗'}
                      </Typography>
                    </Box>
                  </Box>
                </Popover>

                <Divider />

                {/* Current Time Display */}
                <Box textAlign="center" style={{ 
                  paddingTop: isMobile ? 12 : 16, 
                  paddingBottom: isMobile ? 12 : 16 
                }}>
                  <Typography 
                    variant={isMobile ? "body1" : "h6"} 
                    color="textSecondary" 
                    style={{ marginBottom: isMobile ? 6 : 8 }}
                  >
                    Current Time
                  </Typography>
                  <Typography 
                    variant={isMobile ? "h5" : "h4"} 
                    style={{ fontWeight: 'bold', color: '#1976d2' }}
                  >
                    {formatTime(currentTime)}
                  </Typography>
                  <Typography 
                    variant={isMobile ? "caption" : "body2"} 
                    color="textSecondary"
                    style={{ 
                      fontSize: isMobile ? '0.7rem' : undefined,
                      marginTop: isMobile ? 4 : 0
                    }}
                  >
                    {currentTime.toLocaleDateString('en-US', { 
                      weekday: isMobile ? 'short' : 'long', 
                      year: 'numeric', 
                      month: isMobile ? 'short' : 'long', 
                      day: 'numeric' 
                    })}
                  </Typography>
                </Box>
              </div>
            </CardContent>
          </StyledCard2>
        </Grid>
        )}

        {/* Right Section */}
        {(!isMobile || mobileTab === 'logs') && (
        <Grid item xs={12} md={6}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '16px' : '24px' }}>
            {/* Top Card - Time Mode Buttons */}
            <StyledCard>
              <CardContent style={{ padding: isMobile ? 16 : 24 }}>
              {!isMobile && (
                <>
                <Typography 
                  variant={isMobile ? "body1" : "h6"} 
                  style={{ 
                    marginBottom: isMobile ? 16 : 24, 
                    fontWeight: 'bold',
                    textAlign: isMobile ? 'center' : 'left'
                  }}
                >
                  Time Keeping Modes
                </Typography>
                
                <Grid container spacing={isMobile ? 1 : 2}>
                  {timeButtons.map((button) => (
                    <Grid 
                      item 
                      xs={6} 
                      sm={isTablet ? 6 : 3} 
                      md={6} 
                      lg={3} 
                      key={button.id}
                    >
                      <TimeButton
                        className={button.className}
                        fullWidth
                        startIcon={button.icon}
                        onClick={() => handleModeChange(button.id)}
                        style={ selectedMode === button.id ? {
                          opacity:  1,
                          transform:  'scale(1.05)',
                          transition: 'all 0.2s ease-in-out',
                          border: '2px solid #333',
                          backgroundColor:  '#2094F3'
                        } : {
                          opacity: 0.7,
                          transform: 'scale(1)',
                          transition: 'all 0.2s ease-in-out',
                          border: '1px solid transparent',
                        }
                      }
                      >
                        {button.label}
                      </TimeButton>
                    </Grid>
                  ))}
                </Grid>
                  </>
                )}
                {/* Mode-specific Statistics */}
                <Box style={{ marginTop: isMobile ? 16 : 24 }}>
                  <Divider style={{ marginBottom: isMobile ? 12 : 16 }} />
                  
                  {(() => {
                    const stats = getModeStats();
                    const timeStats = stats.timeStats;
                    
                    return (
                      <Box>
                        {/* Main Statistics */}
                        <Grid container spacing={isMobile ? 1 : 2}>
                          {timeStats && (
                            <Grid item xs={12} sm={12}>
                              <Box style={{
                                textAlign: 'center',
                                padding: isMobile ? 12 : 16,
                                backgroundColor: `${timeStats.color}10`,
                                borderRadius: isMobile ? 6 : 8,
                                border: `1px solid ${timeStats.color}30`,
                              }}>
                                <Typography 
                                  variant={isMobile ? "h5" : "h4"} 
                                  style={{ 
                                    fontWeight: 'bold', 
                                    color: timeStats.color,
                                    marginBottom: 4
                                  }}
                                >
                                  {timeStats.count}
                                </Typography>
                                <Typography 
                                  variant={isMobile ? "caption" : "body2"} 
                                  style={{ 
                                    fontWeight: 'bold',
                                    color: timeStats.color,
                                    marginBottom: 2
                                  }}
                                >
                                  {timeStats.title}
                                </Typography>
                              </Box>
                            </Grid>
                          )}
                          
                          {/* <Grid item xs={12} sm={timeStats ? 6 : 12}>
                            <Box style={{
                              textAlign: 'center',
                              padding: isMobile ? 12 : 16,
                              backgroundColor: '#f5f5f5',
                              borderRadius: isMobile ? 6 : 8,
                              border: '1px solid #e0e0e0',
                            }}>
                              <Typography 
                                variant={isMobile ? "h5" : "h4"} 
                                style={{ 
                                  fontWeight: 'bold', 
                                  color: '#1976d2',
                                  marginBottom: 4
                                }}
                              >
                                {stats.total}
                              </Typography>
                              <Typography 
                                variant={isMobile ? "caption" : "body2"} 
                                style={{ 
                                  fontWeight: 'bold',
                                  color: '#1976d2',
                                  marginBottom: 2
                                }}
                              >
                                Total {getModeLabel(selectedMode)} Records
                              </Typography>
                              <Typography 
                                variant="caption" 
                                color="textSecondary"
                                style={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
                              >
                                {stats.percentage}% of all time logs
                              </Typography>
                            </Box>
                          </Grid> */}
                        </Grid>
                      </Box>
                    );
                  })()}
                </Box>
              </CardContent>
            </StyledCard>
            {/* Bottom Card - Time Logs */}
            <StyledCard>
              <CardContent style={{ padding: isMobile ? 16 : 24 }}>
                <Box style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: isMobile ? 16 : 24,
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  gap: isMobile ? 12 : 0
                }}>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <AccessTimeIcon
                      style={{
                        marginRight: 8,
                        color: '#1976d2',
                        fontSize: isMobile ? '1.2rem' : '1.5rem'
                      }}
                    />
                    <Typography variant={isMobile ? 'body1' : 'h6'} style={{ fontWeight: 'bold' }}>
                      {`${getModeLabel(selectedMode)} Logs`}
                    </Typography>
                  </Box>

                  {user && user.role >= 3 && groupStores.length > 1 && (
                    <Autocomplete
                      options={groupStores}
                      value={selectedStore}
                      onChange={handleStoreChange}
                      style={{
                        minWidth: isMobile ? 150 : 200,
                        display: isMobile && mobileTab !== 'logs' ? 'none' : 'block'
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Store" variant="outlined" size="small" />
                      )}
                    />
                  )}
                </Box>

                {/* Loading indicator for records */}
                {isLoadingRecords && (
                  <Box style={{ 
                    textAlign: 'center', 
                    padding: isMobile ? 16 : 24 
                  }}>
                    <Typography variant="body2" color="textSecondary">
                      Loading today's records...
                    </Typography>
                  </Box>
                )}

                <Box style={{ 
                  overflowY: 'auto', 
                  paddingRight: isMobile ? '4px' : '8px', 
                  maxHeight: isMobile ? '400px' : '760px'
                }}>
                  {(() => {
                    const logsToShow = getFilteredLogs();
                    
                    // Apply pagination
                    const startIndex = recordsPage * recordsPerPage;
                    const endIndex = startIndex + recordsPerPage;
                    const paginatedLogs = logsToShow.slice(startIndex, endIndex);
                    
                    if (logsToShow.length === 0 && !isLoadingRecords) {
                      return (
                        <Box style={{ 
                          textAlign: 'center', 
                          paddingTop: isMobile ? 24 : 32, 
                          paddingBottom: isMobile ? 24 : 32 
                        }}>
                          <Typography 
                            variant={isMobile ? "caption" : "body2"} 
                            color="textSecondary"
                          >
                            {`No ${getModeLabel(selectedMode).toLowerCase()} logs yet. Switch to this mode and scan QR codes!`}
                          </Typography>
                        </Box>
                      );
                    }

                    return paginatedLogs.map((log) => {
                      return (
                        <LogCard key={log.id} elevation={2}>
                          <div style={{ 
                            display: 'flex', 
                            flexDirection: isMobile ? 'column' : 'row',
                            alignItems: isMobile ? 'center' : 'flex-start', 
                            gap: isMobile ? '12px' : '24px', 
                            height: '100%' 
                          }}>
                            <div style={{ 
                              position: 'relative',
                              width: isMobile ? '200px' : '250px', 
                              height: isMobile ? '150px' : '200px',
                              flexShrink: 0,
                              borderRadius: isMobile ? '8px' : '12px',
                              overflow: 'hidden',
                              border: `${isMobile ? '2px' : '3px'} solid #e0e0e0`,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}>
                              <img 
                                src={log.capturedPhoto} 
                                alt={`${log.employeeName} scan`}
                                style={{ 
                                  width: '100%', 
                                  height: '100%', 
                                  objectFit: 'cover',
                                  display: 'block'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              <div style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#f5f5f5',
                                display: 'none',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: isMobile ? '24px' : '36px',
                                fontWeight: 'bold',
                                color: '#999'
                              }}>
                                {log.employeeName?.charAt(0) || '?'}
                              </div>
                              {/* Download button - visible only when using browser storage */}
                              {storageMethod === 'localStorage' && (
                                <IconButton
                                  size="small"
                                  onClick={() => downloadLogImage(log)}
                                  style={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4,
                                    backgroundColor: 'rgba(255,255,255,0.8)'
                                  }}
                                >
                                  <CloudDownloadIcon style={{ fontSize: isMobile ? '1rem' : '1.2rem' }} />
                                </IconButton>
                              )}
                            </div>
                            <Box style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              gap: isMobile ? '8px' : '10px', 
                              flexGrow: 1, 
                              padding: 2,
                              textAlign: isMobile ? 'center' : 'left'
                            }}>
                                <Box style={{
                                  display: 'flex', 
                                  paddingTop: isMobile ? '8px' : '28px', 
                                  flexDirection: isMobile ? 'column' : 'row', 
                                  gap: '5px', 
                                  alignItems: isMobile ? 'center' : 'center'
                                }}>
                                    <Box style={{ 
                                      display: 'flex', 
                                      flexDirection: 'column', 
                                      flexGrow: 3, 
                                      alignItems: isMobile ? 'center' : 'flex-start'
                                    }}>
                                        <Typography 
                                          variant={isMobile ? "h6" : "h5"} 
                                          style={{ 
                                            fontWeight: 'bold', 
                                            marginBottom: '8px', 
                                            fontSize: isMobile ? '1.1rem' : '1.3rem'
                                          }}
                                        >
                                            {log.employeeName || 'Unknown Employee'}
                                        </Typography>
                                        <Typography 
                                          variant={isMobile ? "body2" : "h6"} 
                                          color="textSecondary" 
                                          style={{ 
                                            marginBottom: '12px', 
                                            fontSize: isMobile ? '0.9rem' : '1.1rem'
                                          }}
                                        >
                                            {log.employeePosition || 'Unknown Position'}
                                        </Typography>
                                    </Box>
                                    <Box style={{ 
                                      display: 'flex', 
                                      flexDirection: 'column', 
                                      gap: '5px', 
                                      flexGrow: 1, 
                                      alignItems: isMobile ? 'center' : 'flex-end', 
                                      justifyContent: 'center' 
                                    }}>
                                        <Chip
                                            label={getModeLabel(log.mode)}
                                            color={'primary'}
                                            size="medium"
                                            style={{
                                            fontWeight: 'bold',
                                            fontSize: isMobile ? '0.75rem' : '0.85rem',
                                            height: isMobile ? '28px' : '32px',
                                            minWidth: isMobile ? '70px' : '80px', 
                                            marginBottom: '8px'
                                            }}
                                        />
                                        <Typography 
                                          variant="body1" 
                                          style={{
                                            display: 'flex',
                                            fontWeight: '600',
                                            fontSize: isMobile ? '0.85rem' : '0.95rem',
                                            color: '#555',
                                             marginBottom: '12px',
                                             textAlign: isMobile ? 'center' : 'right'
                                          }}
                                        >
                                            {formatLogTime(log.timestamp)}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography 
                                  variant="body1" 
                                  color="textSecondary" 
                                  style={{ 
                                    display: 'block',
                                    backgroundColor: '#f8f9fa',
                                    padding: isMobile ? '6px 10px' : '8px 12px',
                                    borderRadius: '6px',
                                    fontFamily: 'monospace',
                                    fontSize: isMobile ? '0.8rem' : '0.9rem',
                                    border: '1px solid #e9ecef',
                                    wordBreak: 'break-all'
                                  }}
                                >
                                    QR: {log.qrCode}
                                </Typography>
                            </Box>
                            
                          </div>
                        </LogCard>
                      );
                    });
                  })()}
                </Box>

                {(() => {
                  const logsToShow = getFilteredLogs();
                  const totalPages = Math.ceil(logsToShow.length / recordsPerPage);
                  
                  return logsToShow.length > 0 && (
                    <>
                      {/* Pagination Controls */}
                      {totalPages > 1 && (
                        <Box style={{ 
                          display: 'flex', 
                          justifyContent: 'center', 
                          alignItems: 'center',
                          gap: isMobile ? '8px' : '12px',
                          marginTop: isMobile ? 12 : 16,
                          paddingTop: isMobile ? 12 : 16,
                          borderTop: '1px solid #e0e0e0' 
                        }}>
                          <Button
                            size="small"
                            disabled={recordsPage === 0}
                            onClick={() => setRecordsPage(recordsPage - 1)}
                            style={{
                              minHeight: isMobile ? 32 : 36,
                              fontSize: isMobile ? '0.7rem' : '0.8rem'
                            }}
                          >
                            Previous
                          </Button>
                          
                          <Typography 
                            variant="caption" 
                            color="textSecondary"
                            style={{ 
                              fontSize: isMobile ? '0.7rem' : '0.75rem',
                              minWidth: isMobile ? '80px' : '100px',
                              textAlign: 'center'
                            }}
                          >
                            Page {recordsPage + 1} of {totalPages}
                          </Typography>
                          
                          <Button
                            size="small"
                            disabled={recordsPage >= totalPages - 1}
                            onClick={() => setRecordsPage(recordsPage + 1)}
                            style={{
                              minHeight: isMobile ? 32 : 36,
                              fontSize: isMobile ? '0.7rem' : '0.8rem'
                            }}
                          >
                            Next
                          </Button>
                        </Box>
                      )}
                      
                      {/* Summary Information */}
                      <Box style={{ 
                        marginTop: isMobile ? 8 : 12, 
                        paddingTop: isMobile ? 8 : 12, 
                        borderTop: totalPages > 1 ? 'none' : '1px solid #e0e0e0' 
                      }}>
                        <Typography 
                          variant="caption" 
                          color="textSecondary" 
                          style={{ 
                            textAlign: 'center', 
                            display: 'block',
                            fontSize: isMobile ? '0.7rem' : undefined
                          }}
                                                  >
                            {`Showing ${Math.min(recordsPerPage, logsToShow.length - (recordsPage * recordsPerPage))} of ${logsToShow.length} ${getModeLabel(selectedMode).toLowerCase()} entries`}
                        </Typography>
                      </Box>
                    </>
                  );
                })()}
              </CardContent>
            </StyledCard>
          </div>
        </Grid>
        )}
      </Grid>
      
      {/* Storage Settings Dialog */}
      <Dialog 
      open={isStorageSettingsOpen} 
      onClose={() => setIsStorageSettingsOpen(false)}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle style={{ 
        textAlign: 'center',
        paddingBottom: isMobile ? 12 : 16
      }}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <SettingsIcon style={{ color: '#1976d2' }} />
          <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: 'bold' }}>
            Image Storage Settings
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent style={{ paddingTop: isMobile ? 8 : 16 }}>
        <Box style={{ marginBottom: isMobile ? 16 : 24 }}>
          <Typography variant="body2" color="textSecondary" style={{ 
            textAlign: 'center',
            marginBottom: isMobile ? 12 : 16,
            fontSize: isMobile ? '0.85rem' : undefined
          }}>
            Choose where to save captured images during time keeping
          </Typography>
          
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              value={storageMethod}
              onChange={(e) => {
                const newValue = e.target.value;
                if (newValue !== storageMethod && !isAuthorizingStorage) {
                  changeStorageMethod(newValue);
                }
              }}
            >
              <FormControlLabel
                value="localStorage"
                control={<Radio color="primary" disabled={isAuthorizingStorage} />}
                label={
                  <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CloudIcon style={{ color: '#4caf50' }} />
                    <Box>
                      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                        Browser Storage
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Save images in browser cache (quick access, limited storage)
                      </Typography>
                    </Box>
                  </Box>
                }
                style={{ 
                  margin: isMobile ? '8px 0' : '12px 0',
                  padding: isMobile ? '8px' : '12px',
                  border: storageMethod === 'localStorage' ? '2px solid #4caf50' : '1px solid #e0e0e0',
                  borderRadius: '8px',
                  backgroundColor: storageMethod === 'localStorage' ? '#f1f8e9' : 'transparent'
                }}
              />
              
              <FormControlLabel
                value="deviceStorage"
                control={<Radio color="primary" disabled={isAuthorizingStorage} />}
                label={
                  <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FolderOpenIcon style={{ color: '#2196f3' }} />
                    <Box>
                      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                        Device Storage
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Save images to your device folder (permanent storage)
                      </Typography>
                    </Box>
                  </Box>
                }
                style={{ 
                  margin: isMobile ? '8px 0' : '12px 0',
                  padding: isMobile ? '8px' : '12px',
                  border: storageMethod === 'deviceStorage' ? '2px solid #2196f3' : '1px solid #e0e0e0',
                  borderRadius: '8px',
                  backgroundColor: storageMethod === 'deviceStorage' ? '#e3f2fd' : 'transparent'
                }}
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Storage Status */}
        <Box style={{ 
          padding: isMobile ? 12 : 16,
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          marginBottom: isMobile ? 16 : 20
        }}>
          <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 8 }}>
            Current Status:
          </Typography>
          
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 8 }}>
            <StorageIcon style={{ 
              color: storageMethod === 'localStorage' ? '#4caf50' : '#2196f3',
              fontSize: isMobile ? '1rem' : '1.2rem'
            }} />
            <Typography variant="body2">
              Storage Method: <strong>{storageMethod === 'localStorage' ? 'Browser Storage' : 'Device Storage'}</strong>
            </Typography>
          </Box>
          
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: storageAuthorized ? '#4caf50' : '#f44336'
            }} />
            <Typography variant="body2">
              Authorization Status: <strong>{storageAuthorized ? 'Authorized' : 'Not Authorized'}</strong>
            </Typography>
          </Box>
          
          {storageMethod === 'deviceStorage' && !storageAuthorized && (
            <Alert severity="warning" style={{ marginTop: 12, fontSize: isMobile ? '0.8rem' : undefined }}>
              Device storage requires authorization before saving images
            </Alert>
          )}
          
          {storageMethod === 'deviceStorage' && storageAuthorized && deviceStorageHandle && (
            <Alert severity="success" style={{ marginTop: 12, fontSize: isMobile ? '0.8rem' : undefined }}>
              {`Images will be saved to: ${deviceStorageHandle.name || 'Selected folder'}`}
            </Alert>
          )}
          
          {storageMethod === 'deviceStorage' && !storageAuthorized && localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY) === 'true' && (
            <Alert severity="info" style={{ marginTop: 12, fontSize: isMobile ? '0.8rem' : undefined }}>
              {`Previously authorized folder: ${localStorage.getItem(DEVICE_STORAGE_FOLDER_NAME_KEY) || 'Unknown'}. Click "Authorize Device Storage" below to reselect and continue.`}
            </Alert>
          )}
        </Box>

        {/* File Naming Information */}
        <Box style={{ 
          padding: isMobile ? 12 : 16,
          backgroundColor: '#e3f2fd',
          borderRadius: '8px',
          border: '1px solid #2196f3'
        }}>
          <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 8 }}>
            File Naming Convention:
          </Typography>
          <Typography variant="caption" color="textSecondary" style={{ 
            fontFamily: 'monospace',
            fontSize: isMobile ? '0.7rem' : '0.75rem',
            wordBreak: 'break-all'
          }}>
            {`${IMAGE_STORAGE_PREFIX}[employeeId]_[status]_[timestamp].jpg`}
          </Typography>
          <Typography variant="caption" color="textSecondary" style={{ 
            display: 'block',
            marginTop: 4,
            fontSize: isMobile ? '0.7rem' : '0.75rem'
          }}>
            Example: qr_scan_images_001_time-in_1640995200000.jpg
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions style={{ padding: isMobile ? 16 : 24 }}>
        {storageMethod === 'deviceStorage' && !storageAuthorized && (
          <>
            {localStorage.getItem(DEVICE_STORAGE_AUTHORIZED_KEY) === 'true' ? (
              <Button
                onClick={() => {
                  setIsStorageSettingsOpen(false);
                  setTimeout(() => showReauthDialog(), 300);
                }}
                color="primary"
                variant="contained"
                fullWidth={isMobile}
                disabled={isAuthorizingStorage}
                style={{ marginRight: isMobile ? 0 : 8, marginBottom: isMobile ? 8 : 0 }}
              >
                Quick Reauthorize
              </Button>
            ) : (
              <Button
                onClick={requestDeviceStorageAuthorization}
                color="primary"
                variant="contained"
                fullWidth={isMobile}
                disabled={isAuthorizingStorage}
                style={{ marginRight: isMobile ? 0 : 8, marginBottom: isMobile ? 8 : 0 }}
              >
                {isAuthorizingStorage ? 'Authorizing...' : 'Authorize Device Storage'}
              </Button>
            )}
          </>
        )}
        
        <Button 
          onClick={() => setIsStorageSettingsOpen(false)} 
          color="primary"
          variant={isMobile ? "outlined" : "text"}
          fullWidth={isMobile}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>

    {/* Reauthorization Dialog */}
    <Dialog 
      open={isReauthDialogOpen} 
      onClose={isAuthorizingStorage ? undefined : () => setIsReauthDialogOpen(false)}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      disableEscapeKeyDown={isAuthorizingStorage}
    >
      <DialogTitle style={{ 
        textAlign: 'center',
        paddingBottom: isMobile ? 12 : 16
      }}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <FolderOpenIcon style={{ color: '#2196f3', fontSize: '2rem' }} />
          <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: 'bold' }}>
            Welcome Back!
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent style={{ paddingTop: isMobile ? 8 : 16 }}>
        <Box style={{ textAlign: 'center', marginBottom: isMobile ? 16 : 24 }}>
          <Typography variant="body1" style={{ 
            marginBottom: isMobile ? 12 : 16,
            fontSize: isMobile ? '0.95rem' : '1.1rem',
            lineHeight: 1.5
          }}>
            You previously used device storage for saving time-keeping images.
          </Typography>
          
          {localStorage.getItem(DEVICE_STORAGE_FOLDER_NAME_KEY) && (
            <Box style={{
              padding: isMobile ? 12 : 16,
              backgroundColor: '#e3f2fd',
              borderRadius: '8px',
              border: '1px solid #2196f3',
              marginBottom: isMobile ? 16 : 20
            }}>
              <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                Previously Selected Folder:
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ 
                fontFamily: 'monospace',
                fontSize: isMobile ? '0.85rem' : '0.9rem'
              }}>
                {localStorage.getItem(DEVICE_STORAGE_FOLDER_NAME_KEY)}
              </Typography>
            </Box>
          )}
          
          <Typography variant="body2" color="textSecondary" style={{ 
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            lineHeight: 1.4
          }}>
            For security reasons, you need to reselect your storage folder to continue saving images to your device.
          </Typography>
        </Box>
        
        <Alert severity="info" style={{ 
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          marginBottom: isMobile ? 16 : 20
        }}>
          <strong>Tip:</strong> You can select the same folder as before, or choose a different one for your time-keeping images.
        </Alert>
      </DialogContent>
      
      <DialogActions style={{ 
        padding: isMobile ? 16 : 24,
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '8px' : '12px'
      }}>
                 <Button
           onClick={handleReauthFromDialog}
           color="primary"
           variant="contained"
           fullWidth={isMobile}
           disabled={isAuthorizingStorage}
           startIcon={isAuthorizingStorage ? <StorageIcon /> : <FolderOpenIcon />}
           style={{ 
             minHeight: isMobile ? 48 : 42,
             fontSize: isMobile ? '1rem' : '0.95rem',
             fontWeight: 'bold',
             opacity: isAuthorizingStorage ? 0.7 : 1,
             transition: 'opacity 0.3s ease'
           }}
         >
           {isAuthorizingStorage ? 'Selecting Folder...' : 'Select Storage Folder'}
         </Button>
        
        <Button 
          onClick={() => {
            setIsReauthDialogOpen(false);
            // Switch to localStorage as fallback
            changeStorageMethod('localStorage');
          }} 
          color="secondary"
          variant={isMobile ? "outlined" : "text"}
          fullWidth={isMobile}
          style={{ 
            minHeight: isMobile ? 48 : 42,
            fontSize: isMobile ? '0.9rem' : '0.85rem'
          }}
        >
          Use Browser Storage Instead
        </Button>
      </DialogActions>
    </Dialog>

    {/* Initial Storage Choice Dialog */}
    <Dialog 
      open={isInitialStorageChoiceOpen} 
      onClose={() => {
        // Fallback to browser storage if user closes dialog without choosing
        handleInitialStorageChoice('localStorage');
      }}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle style={{ 
        textAlign: 'center',
        paddingBottom: isMobile ? 12 : 16
      }}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <StorageIcon style={{ color: '#1976d2', fontSize: '2rem' }} />
          <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: 'bold' }}>
            Choose Image Storage
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent style={{ paddingTop: isMobile ? 8 : 16 }}>
        <Box style={{ textAlign: 'center', marginBottom: isMobile ? 16 : 24 }}>
          <Typography variant="body1" style={{ 
            marginBottom: isMobile ? 16 : 20,
            fontSize: isMobile ? '0.95rem' : '1.1rem',
            lineHeight: 1.5
          }}>
            Where would you like to save captured time-keeping images?
          </Typography>
          
          {/* Device Storage Option */}
          <Card style={{ 
            marginBottom: isMobile ? 12 : 16,
            border: '2px solid #2196f3',
            cursor: 'pointer'
          }} onClick={() => handleInitialStorageChoice('deviceStorage')}>
            <CardContent style={{ padding: isMobile ? 16 : 20 }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: 8 }}>
                <FolderOpenIcon style={{ color: '#2196f3', fontSize: '2rem' }} />
                <Typography variant="h6" style={{ fontWeight: 'bold', color: '#2196f3' }}>
                  Device Storage (Recommended)
                </Typography>
              </Box>
              <Typography variant="body2" color="textSecondary" style={{ 
                fontSize: isMobile ? '0.85rem' : '0.95rem',
                lineHeight: 1.4,
                marginBottom: 8
              }}>
                Save images directly to a folder on your device. Images are stored permanently and won't be lost when clearing browser data.
              </Typography>
              <Box style={{ 
                backgroundColor: '#e3f2fd', 
                padding: isMobile ? 8 : 12, 
                borderRadius: 4, 
                marginTop: 8 
              }}>
                <Typography variant="caption" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                  ✓ Permanent storage ✓ Better organization ✓ Easy access
                </Typography>
              </Box>
            </CardContent>
          </Card>
          
          {/* Browser Storage Option */}
          <Card style={{ 
            border: '1px solid #4caf50',
            cursor: 'pointer'
          }} onClick={() => handleInitialStorageChoice('localStorage')}>
            <CardContent style={{ padding: isMobile ? 16 : 20 }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: 8 }}>
                <CloudIcon style={{ color: '#4caf50', fontSize: '2rem' }} />
                <Typography variant="h6" style={{ fontWeight: 'bold', color: '#4caf50' }}>
                  Browser Storage
                </Typography>
              </Box>
              <Typography variant="body2" color="textSecondary" style={{ 
                fontSize: isMobile ? '0.85rem' : '0.95rem',
                lineHeight: 1.4,
                marginBottom: 8
              }}>
                Save images in browser cache. Quick setup with no file permissions needed, but images may be lost if browser data is cleared.
              </Typography>
              <Box style={{ 
                backgroundColor: '#f1f8e9', 
                padding: isMobile ? 8 : 12, 
                borderRadius: 4, 
                marginTop: 8 
              }}>
                <Typography variant="caption" style={{ fontWeight: 'bold', color: '#4caf50' }}>
                  ✓ No setup required ✓ Works on all devices ✓ Privacy focused
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Box>
        
        <Alert severity="info" style={{ 
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          marginTop: isMobile ? 16 : 20
        }}>
          <strong>Note:</strong> You can change this setting later from the Storage Settings menu.
        </Alert>
      </DialogContent>
      
      <DialogActions style={{ 
        padding: isMobile ? 16 : 24,
        justifyContent: 'center'
      }}>
        <Typography variant="caption" color="textSecondary" style={{ 
          fontSize: isMobile ? '0.7rem' : '0.75rem',
          textAlign: 'center'
        }}>
          Click on your preferred option above to continue
        </Typography>
      </DialogActions>
    </Dialog>
    </Container>
    {/* Mobile bottom navigation: Scan / Logs toggle */}
    {isMobile && (
      <BottomNavigation
        value={mobileTab}
        onChange={(_, newValue) => setMobileTab(newValue)}
        showLabels
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#fff',
        }}
      >
        <BottomNavigationAction label="Scan" value="scan" icon={<CameraAltIcon />} />
        <BottomNavigationAction label="Logs" value="logs" icon={<AccessTimeIcon />} />
      </BottomNavigation>
    )}
  </>
  );
};

export default QrScanTimeKeep;

